<template>
    <div class="relatorios-container">
        <!-- TOOLBAR VISUALIZAÇÃO -->
        <div v-if="!editMode" class="top-bar">
            <div class="datepicker-input-group">
                <searchDatePicker :key="formatDate(selectedDate)" v-model="selectedDate" :lang="ptbr" class="custom-date" type="date"
                    format="DD/MM/YYYY" placeholder="Selecione uma data">
                    <template v-slot:input="slotProps">
                        <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
                    </template>
                    <img height="1em" class="ml-2" src="../../assets/CALENDAR-WEEK.svg" />
                </searchDatePicker>
            </div>

            <img class="action-btn img-btn ml-3" src="../../assets/SEARCH-ICON.svg" @click="searchReport('pesquisa')"
                :title="$t('buscar-relatorio')" />

            <img class="action-btn img-btn ml-2" src="../../assets/producao.png"
                :title="$t('gerenciar-modelos-relatorio')" @click="openReportModelsModal"
                v-if="user.Permissions.editarrelatorios && user.Permissions.editarrelatorios.allowed && user.Permissions.editarrelatorios.permission"
            />
            <span v-if="reportTemplateName" class="selected-model-label">{{ reportTemplateName }}</span>

            <div class="save-picker toolbar-right-view">
                <!-- Badge de envios diários -->
                <div class="limit-wrapper">
                    <span v-if="sendCount >= sendLimit" class="alert-exclamation">
                        !
                        <div class="commercial-tooltip">
                            <div class="tooltip-title">Limite de envios atingido</div>
                            <div>Entre em contato com o setor comercial da Pentagro para contratar um novo pacote de mensagens.</div>
                            <img src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://api.whatsapp.com/send/?phone=5516997046356" alt="QR WhatsApp Comercial Pentagro" class="tooltip-qr" />
                            <div class="tooltip-qr-label">WhatsApp Comercial Pentagro</div>
                        </div>
                    </span>
                    <span class="limit-badge">ENVIOS HOJE: {{ sendCount }}/{{ sendLimit }}</span>
                </div>

                <!-- Botão envio manual (apenas se sendMode === 'manual') -->
                <svg v-if="sendMode === 'manual'" viewBox="0 0 24 24" width="26" height="26" stroke="#f37021" fill="none" stroke-width="2"
                    class="action-btn ml-2" style="cursor:pointer;" title="Enviar relatório agora" @click="sendManual">
                    <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
                </svg>

                <!-- Histórico de envios -->
                <img class="action-btn img-btn ml-2" src="../../assets/Planejamento.png" title="Histórico de envios" @click="$bvModal.show('SendHistoryModal')" />

                <!-- Lápis: entrar em modo de edição -->
                <img v-if="reportTemplateName && user.Permissions.editarrelatorios && user.Permissions.editarrelatorios.allowed && user.Permissions.editarrelatorios.permission"
                    class="action-btn img-btn ml-2" src="../../assets/EDIT-PENCIL.svg" title="Editar modelo atual" @click="enterModelEditMode" />

                <!-- Engrenagem: configuração de envio -->
                <img class="action-btn img-btn ml-2" src="../../assets/configuracoes2.png" title="Configuração de envio" @click="openSendConfig" />

                <!-- PDF -->
                <img id="botaoExportarPDF" class="action-btn img-btn ml-2" src="../../assets/pdf.svg"
                    :title="$t('export-pdf')" @click="exportPDF" />
            </div>
        </div>

        <!-- TOOLBAR EDIÇÃO -->
        <div v-if="editMode" class="top-bar">
            <div class="datepicker-input-group">
                <searchDatePicker :key="formatDate(selectedDate)" v-model="selectedDate" :lang="ptbr" class="custom-date" type="date"
                    format="DD/MM/YYYY" placeholder="Selecione uma data" :disabled="true">
                    <template v-slot:input="slotProps">
                        <input type="text" v-bind="slotProps.props" v-on="slotProps.events" />
                    </template>
                    <img height="1em" class="ml-2" src="../../assets/CALENDAR-WEEK.svg" />
                </searchDatePicker>
            </div>

            <img class="action-btn img-btn ml-3" src="../../assets/SEARCH-ICON.svg" @click="searchReport('pesquisa')"
                :title="$t('buscar-relatorio')" />

            <span v-if="reportTemplateName" class="selected-model-label">{{ reportTemplateName }}</span>

            <!-- Badge de envios (somente leitura no modo edição) -->
            <span class="limit-badge ml-2">ENVIOS HOJE: {{ sendCount }}/{{ sendLimit }}</span>

            <!-- Botões de adição de elementos -->
            <img class="action-btn img-btn-big img-btn-txt ml-2" src="../../assets/HEADER.svg"
                :title="$t('adicionar-cabecalho')" @click="addHeader" />
            <img class="action-btn img-btn-big img-btn-txt ml-2" src="../../assets/TEXT-AREA.svg"
                :title="$t('adicionar-area-txt')" @click="openTextModal" />
            <img class="action-btn img-btn img-btn-graph" src="../../assets/TABLE.svg"
                :title="$t('adicionar-tabela')" @click="addTable" />
            <!-- Relato de Turno -->
            <img class="action-btn img-btn-closing" src="../../assets/mostrarHistoricoAcoes.png"
                title="Adicionar Relato de Turno" @click="openAddRelatoTurno" />

            <!-- Checklist (Ocorrências) -->
            <img class="action-btn img-btn img-btn-table-oc ml-2" src="../../assets/Planejamento.png"
                :title="$t('adicionar-tabela-ocorrencias')" @click="addTableOccurrence" />

            <img class="action-btn img-btn img-btn-graph" src="../../assets/GRAPH-UP.svg"
                :title="$t('adicionar-grafico')" @click="openGraphSelectionModal" />

            <div class="save-picker">
                <img class="action-btn img-btn ml-2" src="../../assets/atualizar.png" :title="$t('resetar-relatorio')"
                    @click="searchReport('resetar')" />
                <img class="action-btn img-btn ml-2" src="../../assets/salvar.png" :title="$t('salvar-relatorio')"
                    @click="saveReport"
                    v-if="user.Permissions.editarrelatorios && user.Permissions.editarrelatorios.allowed && user.Permissions.editarrelatorios.permission" />
                <!-- Sair do modo de edição sem salvar -->
                <button class="exit-edit-btn ml-2" title="Sair do modo de edição" @click="exitEditMode">✕</button>
            </div>
        </div>

        <!-- Elementos do relatório -->
        <div v-if="elements.length === 0 && !editMode" class="no-config">
            <h1 class="clockText">{{ $t('sem-config-encontrada') }}</h1>
            <img src="../../assets/Monitoramento.png" class="iconPermission" :alt="$t('sem-config-encontrada')"
                :title="$t('sem-config-encontrada')" />
        </div>

        <div ref="reportContainer" class="report-grid-container" :class="{ 'show-grid': editMode }">
            <div class="white-space"></div>
            <div v-for="(element, index) in sortedElements" :key="element.id" class="element-wrapper"
                :data-id="element.id" v-draggable="element" v-resizable="element" @drag-end="updateElementsOrder"
                @resize-end="updateElementsWidth" :style="{
                    position: 'absolute',
                    left: element.position ? element.position.left + 'px' : '20px',
                    top: element.position ? element.position.top + 'px' : '20px',
                    width: element.width
                        ? element.width + 'px'
                        : (element.type === 'chart' ? '450px' : '95%'),

                    height: element.type === 'chart'
                        ? (element.height ? element.height + 'px' : '200px')
                        : 'auto',

                    zIndex: element.type === 'chart'
                        ? 'auto'
                        : sortedElements.length - element.order
                }">
                <img v-if="editMode" src="../../assets/cancel.png" class="remove-btn" :title="'Remover elemento'"
                    @click="removeElement(index)" />
                <img v-if="editMode && element.type !== 'table' && element.type !== 'chart'"
                    class="edit-icon remove-btn edit-btn-elements" src="../../assets/editPen.png"
                    @click="openEditModal(index)" :title="$t('editar-elemento')" />
                <img v-if="editMode && element.type === 'table'"
                    class="edit-icon remove-btn edit-btn-elements" src="../../assets/editPen.png"
                    @click="editTable(index)" :title="$t('editar-elemento')" />
                <img v-if="editMode && element.type == 'chart'" class="edit-icon remove-btn edit-btn-elements"
                    src="../../assets/editPen.png" @click="($event) => openChartEditModal(index, $event)"
                    :title="$t('editar-elemento')" />

                <!-- Header -->
                <div v-if="element.type === 'header'" class="header-box"
                    :style="{ backgroundColor: element.title.color }">
                    <span>{{ element.title.text }}</span>
                </div>

                <!-- RENDER Tabela Ocorrências -->
                <div v-if="element.type === 'tableOccurrence'" class="table-occurrence-wrapper">
                    <table class="my-custom-table-class">
                        <thead>
                            <tr>
                                <th v-for="(header, hIndex) in element.tableOccurrence.headers" :key="hIndex">
                                    {{ header }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, rIndex) in element.tableOccurrence.rows" :key="rIndex">
                                <td v-for="(cell, cIndex) in row" :key="cIndex">
                                    {{ cell }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>



                <!-- RENDER Widget Relato de Turno -->
                <div v-else-if="element.type === 'relatoTurno'" class="relato-turno-widget">
                    <div class="relato-widget-header" :style="{ backgroundColor: element.title.color || '#333' }">
                        <span>{{ element.title.text }}</span>
                    </div>
                    <div class="relato-sections">
                        <div v-if="element.tabs.includes('relatos')" class="relato-section">
                            <div class="relato-sub-title">Relatos</div>
                            <div class="relato-table-scroll">
                                <table class="relato-pgdi-table">
                                    <thead>
                                        <tr>
                                            <th>Turno</th>
                                            <th>Área</th>
                                            <th>Tipo</th>
                                            <th>Descrição</th>
                                            <th>Usuário</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!shiftReportRelatos || shiftReportRelatos.length === 0">
                                            <td colspan="5" class="relato-empty">Sem dados para a data selecionada.</td>
                                        </tr>
                                        <tr v-for="(row, ri) in shiftReportRelatos" :key="ri">
                                            <td>{{ convertTurno(row.Turno) }}</td>
                                            <td>{{ row.Area || '—' }}</td>
                                            <td>{{ row.TipoOcorrido || '—' }}</td>
                                            <td>{{ row.Descricao || '—' }}</td>
                                            <td>{{ row.UserName || '—' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="element.tabs.includes('producao')" class="relato-section">
                            <div class="relato-sub-title">Indicadores de Performance</div>
                            <div class="relato-table-scroll">
                                <table class="relato-pgdi-table">
                                    <thead>
                                        <tr>
                                            <th>Tipo</th>
                                            <th>Indicador</th>
                                            <th>Turno A</th>
                                            <th>Turno B</th>
                                            <th>Turno C</th>
                                            <th>Total</th>
                                            <th>Meta</th>
                                            <th>Observação</th>
                                            <th>Usuário</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!shiftReportProducao || shiftReportProducao.length === 0">
                                            <td colspan="9" class="relato-empty">Sem dados para a data selecionada.</td>
                                        </tr>
                                        <tr v-for="(row, ri) in shiftReportProducao" :key="ri">
                                            <td>{{ row.Type || '—' }}</td>
                                            <td>{{ row.Name || '—' }}</td>
                                            <td>{{ row.TurnoA || '—' }}</td>
                                            <td>{{ row.TurnoB || '—' }}</td>
                                            <td>{{ row.TurnoC || '—' }}</td>
                                            <td>{{ row.Total || '—' }}</td>
                                            <td>{{ row.Meta || '—' }}</td>
                                            <td>{{ row.Observacao || '—' }}</td>
                                            <td>{{ row.UserName || '—' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="element.tabs.includes('manutencao')" class="relato-section">
                            <div class="relato-sub-title">Notas de Manutenção</div>
                            <div class="relato-table-scroll">
                                <table class="relato-pgdi-table">
                                    <thead>
                                        <tr>
                                            <th>Turno</th>
                                            <th>Nota/OS</th>
                                            <th>Prioridade</th>
                                            <th>Área</th>
                                            <th>Equipamento</th>
                                            <th>Oficina</th>
                                            <th>Status</th>
                                            <th>Serviço</th>
                                            <th>Usuário</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!shiftReportManutencao || shiftReportManutencao.length === 0">
                                            <td colspan="9" class="relato-empty">Sem dados para a data selecionada.</td>
                                        </tr>
                                        <tr v-for="(row, ri) in shiftReportManutencao" :key="ri">
                                            <td>{{ convertTurno(row.Turno) }}</td>
                                            <td>{{ row.Descricao || '—' }}</td>
                                            <td>{{ row.Prioridade || '—' }}</td>
                                            <td>{{ row.Area || '—' }}</td>
                                            <td>{{ row.Equipamento || '—' }}</td>
                                            <td>{{ row.Oficina || '—' }}</td>
                                            <td>{{ row.Status || '—' }}</td>
                                            <td>{{ row.OtOs || '—' }}</td>
                                            <td>{{ row.UserName || '—' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="element.tabs.includes('moagem')" class="relato-section">
                            <div class="relato-sub-title">Redução de Moagem</div>
                            <div class="relato-table-scroll">
                                <table class="relato-pgdi-table">
                                    <thead>
                                        <tr>
                                            <th>Turno</th>
                                            <th>Início</th>
                                            <th>Término</th>
                                            <th>Duração</th>
                                            <th>Rotação</th>
                                            <th>U.M.</th>
                                            <th>Motivo</th>
                                            <th>Usuário</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!shiftReportMoagem || shiftReportMoagem.length === 0">
                                            <td colspan="8" class="relato-empty">Sem dados para a data selecionada.</td>
                                        </tr>
                                        <tr v-for="(row, ri) in shiftReportMoagem" :key="ri">
                                            <td>{{ convertTurno(row.Turno) }}</td>
                                            <td>{{ row.Inicio || '—' }}</td>
                                            <td>{{ row.Termino || '—' }}</td>
                                            <td>{{ row.Duracao || '—' }}</td>
                                            <td>{{ row.Observacao || '—' }}</td>
                                            <td>{{ row.Um }}</td>
                                            <td>{{ row.Motivo || '—' }}</td>
                                            <td>{{ row.UserName || '—' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- RENDER Tabela -->
                <div v-else-if="element.type === 'table'" class="table-wrapper">
                    <table class="config-table">
                        <tbody>
                            <tr v-for="(row, rIndex) in element.table.cells" :key="'row-' + rIndex">
                                <td v-for="(cell, cIndex) in row" :key="'cell-' + cIndex" class="config-table-cell">
                                    <div v-if="rIndex === 0 && cIndex === 0">
                                        <div class="table-header-actions">
                                            <template v-if="editMode && !element.table.finalized">
                                                <div class="option-select">
                                                    <input type="radio" v-model="element.table.dataType" value="media"
                                                        @change="updateTableDataType(index)" />
                                                    {{ $t('media-text') }}
                                                    <input class="sum-select" type="radio"
                                                        v-model="element.table.dataType" value="soma"
                                                        @change="updateTableDataType(index)" />
                                                    {{ $t('soma-text') }}
                                                    <button class="small-btn finalize-btn" v-if="element.table.isNew"
                                                        @click="confirmOption(index)">
                                                        <i class="fa fa-check"></i>
                                                    </button>
                                                </div>
                                                <div class="table-action-group" v-if="!element.table.isNew">
                                                    <button @click="addRow(index)" class="small-btn add-row-btn"
                                                        :title="$t('add-3-lines')">
                                                        <i class="fa fa-plus-square"></i>
                                                    </button>
                                                    <button @click="addColumn(index)" class="small-btn add-col-btn"
                                                        :title="$t('add-3-col')">
                                                        <i class="fa fa-plus-square"></i>
                                                    </button>
                                                    <button @click="finalizeTable(index)"
                                                        class="small-btn finalize-btn">
                                                        <i class="fa fa-check"></i>
                                                    </button>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <span class="bold-style-colored">
                                                    {{ element.table.dataType === 'media' ? 'MÉDIA' : 'SOMA' }}
                                                </span>
                                            </template>
                                        </div>
                                    </div>

                                    <div v-else-if="rIndex === 0 && cIndex > 0">
                                        <div class="cell-with-edit"
                                            :class="{ 'centered-content cell-edit-padding ': element.table.finalized }">
                                            <template v-if="!element.table.columnHeaders[cIndex]">
                                                <button :disabled="element.table.isNew" class="icon-btn orange"
                                                    @click="openOrangeModal(index, cIndex)">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </template>
                                            <template v-else>
                                                <span class="bold-style">{{ element.table.columnHeaders[cIndex]
                                                }}</span>
                                                <img v-if="editMode && !element.table.finalized"
                                                    class="config-table-icon" src="../../assets/configuracoes2.png"
                                                    @click="openOrangeModal(index, cIndex)" />
                                                <i v-if="(element.table.columnHeaders[cIndex] === 'Meta PGDI' ||
                                                    isMetaTurno(element.table.columnHeaders[cIndex])) &&
                                                    !element.table.finalized" class="fa fa-info-circle meta-info-icon"
                                                    @click.stop="openMetaModalForTable(index, cIndex)"></i>
                                            </template>
                                        </div>
                                    </div>

                                    <div v-else-if="rIndex > 0 && cIndex === 0">
                                        <div class="cell-with-edit">
                                            <template v-if="!element.table.rowIndicators[rIndex]">
                                                <button :disabled="element.table.isNew" class="icon-btn blue"
                                                    @click="openBlueModal(index, rIndex)">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </template>
                                            <template v-else>
                                                <span class="bold-style">{{ element.table.rowIndicators[rIndex]
                                                }}</span>
                                                <img v-if="editMode && !element.table.finalized"
                                                    class="config-table-icon" src="../../assets/configuracoes2.png"
                                                    @click="openBlueModal(index, rIndex)" />
                                            </template>
                                        </div>
                                    </div>

                                    <div v-else :style="getCellStyle(element, cIndex)">
                                        <template v-if="element.table.columnHeaders[cIndex] === 'Meta Plano'">
                                            <span :class="{ 'meta-plano-missing': cell.value === 'Variável não encontrada' }"
                                                  :title="cell.value === 'Variável não encontrada' ? 'Uma ou mais variáveis da equação não possuem dado para este mês' : ''">{{ cell.value }}</span>
                                            <i v-if="editMode && !element.table.finalized && rIndex > 0 && element.table.rowIndicators[rIndex]"
                                               class="fa fa-calculator meta-plano-calc-icon"
                                               title="Configurar equação Meta Plano"
                                               @click.stop="openMetaPlanoModal(index, rIndex, cIndex)"></i>
                                        </template>
                                        <template v-else>{{ cell.value }}</template>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- RENDER Texto -->
                <div v-else-if="element.type === 'text'" class="text-element" :style="{ color: element.text.color }">
                    <div class="text-border">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="element.text.content"></div>
                    </div>
                </div>

                <!-- RENDER Gráfico -->
                <div v-else-if="element.type === 'chart'" class="chart-element">
                <!-- sempre renderiza v-chart, usando default se element.option for vazio -->
                <v-chart ref="myChart" class="v-chart"
                    :setting="{ notMerge: true }"
                    :option="(element.option && Object.keys(element.option).length > 0)
                                ? element.option
                                : createDefaultChartOption(element.chartType)"
                    :style="{
                        width:  element.width  ? element.width  + 'px' : '100%',
                        height: element.height ? element.height + 'px' : '200px'
                    }" />

                <!-- controles de edição -->
                <div v-if="editMode" class="chart-edit-controls">
                    <img class="edit-icon remove-btn edit-btn-elements"
                        src="../../assets/editPen.png"
                        @click="($event) => openChartEditModal(index, $event)"
                        :title="$t('editar-elemento')" />
                </div>
                </div>
            </div>
        </div>

        <b-modal id="reportModelsModal" title="Gerenciar Modelos" size="lg" hide-footer>
            <div class="modal-body">
                <div class="modal-content-wrapper class-modal-model">
                    <div class="btn-container">
                        <button class="btn-new-model" @click="openNewModelModal" :title="$t('criar-novo-modelo')">
                            <img src="../../assets/plus-2.svg" class="btn-icon" />
                            Novo Modelo
                        </button>
                    </div>
                    <div class="models-table-container mb-2">
                        <div v-if="loadingModels" class="loading-overlay">
                            <img class="loading-over" src="../../assets/loading2.gif" />
                        </div>
                        <table class="models-table">
                            <thead>
                                <tr>
                                    <th>Nome do Modelo</th>
                                    <th class="default-header">Padrão</th>
                                    <th class="actions-header-modal">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(model, index) in reportModels" :key="model.id"
                                    :class="{ 'default-model': model.IsDefault }">
                                    <td>
                                        <template v-if="model.editing">
                                            <input v-model="model.editedName" class="input-edit-model" />
                                            <button class="btn-icon-sm-model  text-green-600"
                                                @click="confirmEditModelName(model)">
                                                <img src="../../assets/salvar.png"
                                                    class="action-icon-model save-model" />
                                            </button>
                                            <button class="btn-icon-sm-model text-red-600"
                                                @click="cancelEditModelName(model)">
                                                <img src="../../assets/cancel.png" class="action-icon-model" />
                                            </button>
                                        </template>
                                        <template v-else>
                                            <span>{{ model.Name }}</span>
                                            <button class="btn-icon-sm text-blue-600" @click="startEditModelName(model)"
                                                title="Editar nome">
                                                <img src="../../assets/editInd.png" class="action-icon-model" />
                                            </button>
                                        </template>
                                    </td>

                                    <td class="default-indicator">
                                        <div class="default-indicator-content">
                                            <img v-if="model.IsDefault" src="../../assets/OK-SIGNAL.svg"
                                                class="default-icon" :title="$t('modelo-padrao')" />
                                            <span v-else>-</span>
                                        </div>
                                    </td>
                                    <td class="actions-cell">
                                        <button class="btn-action" @click="viewReportModel(model)"
                                            :title="$t('visualizar-modelo')">
                                            <img src="../../assets/eye.png" class="action-icon" />
                                        </button>
                                        <button class="btn-action" @click="setDefaultModel(model)"
                                            :title="$t('definir-padrao')">
                                            <img src="../../assets/pop2.png" class="action-icon" />
                                        </button>
                                        <button class="btn-action" @click="removeReportModel(model, index)"
                                            :title="$t('remover-modelo')">
                                            <img src="../../assets/cancel.png" class="action-icon" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Modal: Novo Modelo -->
        <b-modal id="newModelModal" title="Novo Modelo" hide-footer>
            <div class="modal-body">
                <div class="form-group">
                    <label for="modelName" class="new-model-name">Nome do Modelo:</label>
                    <input type="text" class="form-control" id="modelName" v-model="newModelName"
                        placeholder="Digite o nome do modelo">
                </div>
                <div class="form-group mt-3">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="isDefault" v-model="isDefaultReport">
                        <label class="custom-control-label" for="isDefault">Definir como modelo padrão</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary" @click="closeNewModelModal">Cancelar</button>
                <button class="btn btn-primary" @click="confirmNewModel" :disabled="!newModelName">Confirmar</button>
            </div>
        </b-modal>

        <!-- Modal: Configurar Header -->
        <b-modal id="HeaderModal" size="md" hide-footer :title="'Adicionar Cabeçalho'" :no-close-on-backdrop="true">
            <HeaderModal :header="headerForm" @save="saveHeader" @close="closeHeaderModal" />
        </b-modal>

        <!-- Modal: Configurar txt -->
        <b-modal id="TextBoxModal" size="lg" hide-footer :title="'Adicionar Texto'" :no-close-on-backdrop="true"
            :dialog-class="'custom-text-modal'">
            <TextBoxModal :textForm="textForm" @save="saveRichText" @close="closeTextModal" />
        </b-modal>

        <!-- Modal: Selecionar Indicador (Blue Modal) -->
        <b-modal id="blueOptModal" hide-footer :title="'Adicionar Item - Linhas'" :no-close-on-backdrop="true"
            :dialog-class="'custom-blue-modal'">
            <BlueOptModal :blueOpt="blueModalForm" :indicators="indicators" @save="saveBlueModal"
                @close="closeBlueModal" />
        </b-modal>

        <!-- Modal: Selecionar Cabeçalho (Orange Modal) -->
        <b-modal id="orangeOptModal" hide-footer :title="'Adicionar Item - Colunas'" :no-close-on-backdrop="true"
            :dialog-class="'custom-modal'">
            <OrangeOptModal :orangeOptions="orangeOptions" @select="selectOrangeOption" @close="closeOrangeModal" />
        </b-modal>

        <!-- Modal: Definir Metas -->
        <b-modal id="goalModal" size="lg" hide-footer :title="'Definir Metas'" :no-close-on-backdrop="true"
            :dialog-class="'custom-goal-modal'">
            <GoalModal :metaSettings="metaSettings" @save="saveMetaModalForTable" @close="closeMetaModalForTable" />
        </b-modal>

        <!-- Modal: Definir Meta de Turno -->
        <b-modal id="turnoMetaModal" size="lg" hide-footer :title="'Definir Meta de Turno'" :no-close-on-backdrop="true"
            :dialog-class="'custom-goal-modal'">
            <TurnoMetaModal :turno="currentTurnoMeta" :metaItems="turnoMetaItems" @save="saveTurnoMeta"
                @close="closeTurnoMetaModal" />
        </b-modal>

        <!-- Modal: Configurar Equação Meta Plano -->
        <MetaPlanoModal
            :key="`mp_${currentMetaPlanoTableIndex}_${currentMetaPlanoRowIndex}`"
            :show="showMetaPlanoModal"
            :indicator-name="currentMetaPlanoIndicator"
            :equation="currentMetaPlanoEquation"
            :comment="currentMetaPlanoComment"
            :report-date="formatDate(selectedDate)"
            @saved="saveMetaPlanoEquation"
            @close="showMetaPlanoModal = false"
        />

        <!-- Modal: Editar Tabela de Ocorrências -->
        <b-modal id="tableOccurrenceModal" size="md" hide-footer :title="'Editar Tabela de Ocorrências'"
            :no-close-on-backdrop="true" :dialog-class="'custom-table-occurrence-modal'">
            <TableOccurrenceModal :occurrenceTable="tableOccurrenceForm" :screensAreas="screensAreas"
                @save="saveTableOccurrence" @close="closeTableOccurrenceModal" />
        </b-modal>

        <!-- Novo Modal: Seleção de Gráfico -->
        <b-modal :title="'Selecione o tipo de Gráfico'" id="chartSelectionModal" hide-footer v-model="showGraphModal"
            @hidden="closeGraphSelectionModal">
            <ChartSelectionModal @select="handleChartSelection" @close="closeGraphSelectionModal" />
        </b-modal>

        <!-- Novo Modal: Seleção de Gráfico Barras -->
        <b-modal id="chartBarConfigModal" :title="'Configurar Gráfico de Barras'" hide-footer
            v-model="showChartBarConfigModal" @hidden="closeChartBarConfigModal">
            <ChartBarConfigModal :config="chartBarConfig" :screensAreas="screensAreas" @save="handleChartBarConfigSave"
                @close="closeChartBarConfigModal" />
        </b-modal>

        <!-- Novo Modal: Configuração da Meta do Gráfico -->
        <b-modal id="chartMetaConfigModal" :title="'Configurar Meta do Gráfico'" hide-footer
            v-model="showChartMetaConfigModal" @hidden="closeChartMetaConfigModal">
            <ChartMetaConfigModal :config="chartMetaConfig" :indicators="indicators" @save="handleChartMetaConfigSave"
                @close="closeChartMetaConfigModal" />
        </b-modal>

        <!-- Loading Overlay -->
        <div v-if="loading" class="loading-overlay">
            <img class="loading-over" src="../../assets/loading2.gif" @click="editReport" />
            <p class="loading-msg">{{ loadingMessage }}</p>
        </div>

        <!-- WhatsApp User Selection Modal -->
        <WhatsAppUserModal v-if="showWhatsAppModal" modelname="whatsappUserModal" :initialUsers="availableUsers"
            :preSelectedUsers="preSelectedWhatsAppUsers" @close="closeWhatsAppModal" @send="handleSaveWhatsAppUsers" />

        <!-- Histórico de envios -->
        <SendHistoryModal />

        <!-- Configuração de envio -->
        <SendConfigModal :initialSendMode="sendMode" @saved="onSendConfigSaved" />

        <!-- Relato de Turno -->
        <RelatoTurnoModal :editing-data="currentRelatoEditData" @confirm="onRelatoConfirm" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import searchDatePicker from "vue2-datepicker";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ptBR from "vue2-datepicker/locale/pt-br";
import { urlMainAPI } from "../../global";
import axios from "axios";
import HeaderModal from "./customReportsComponents/headerModal.vue";
import TextBoxModal from "./customReportsComponents/TextBoxModal.vue";
import BlueOptModal from "./customReportsComponents/blueOptModal.vue";
import OrangeOptModal from "./customReportsComponents/orangeOptModal.vue";
import GoalModal from "./customReportsComponents/goalModal.vue";
import TableOccurrenceModal from "./customReportsComponents/tableOccurrenceModal.vue";
import ChartSelectionModal from "./customReportsComponents/ChartSelectionModal.vue";
import ChartMetaConfigModal from "./customReportsComponents/ChartMetaConfigModal.vue";
import ChartBarConfigModal from "./customReportsComponents/BarChartConfigModal.vue";
import WhatsAppUserModal from './customReportsComponents/WhatsAppUserModal.vue';
import TurnoMetaModal from './customReportsComponents/TurnoMetaModal.vue';
import SendHistoryModal from './customReportsComponents/SendHistoryModal.vue';
import SendConfigModal from './customReportsComponents/SendConfigModal.vue';
import RelatoTurnoModal from './customReportsComponents/RelatoTurnoModal.vue';
import MetaPlanoModal from './customReportsComponents/MetaPlanoModal.vue';
import MediatorIndicatorEditor from '../indicatorEditor/MediatorIndicatorEditor';

import ECharts from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart, PieChart, GaugeChart} from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components';

import pentagroIcon from '@/assets/PentagroIcon.png';
import pentagroBrand from '@/assets/logo-login.png';
import pentagroLogo from '@/assets/logo-header.png';

use([
    CanvasRenderer,
    BarChart,
    LineChart,
    PieChart,
    GaugeChart,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent
])

export default {
    name: "RelatoriosPersonalizados",
    directives: {
        draggable: {
            inserted(el, binding, vnode) {
                const GRID_SIZE = 20;
                let pos = binding.value.position || { left: 40, top: null };
                el.style.position = 'absolute';
                el.style.width = binding.value.width + 'px';
                el.style.left = pos.left + 'px';

                const parent = el.parentElement;
                if (pos.top === null && parent) {
                    const siblings = Array.from(parent.children).filter(child =>
                        child !== el && !child.classList.contains('white-space')
                    );
                    let maxBottom = 0;
                    siblings.forEach(sib => {
                        const bottom = sib.offsetTop + sib.offsetHeight;
                        if (bottom > maxBottom) {
                            maxBottom = bottom;
                        }
                    });
                    pos.top = maxBottom > 0 ? maxBottom + GRID_SIZE : GRID_SIZE;
                }
                el.style.top = pos.top + 'px';
                binding.value.position = pos;

                if (!binding.value.id) {
                    binding.value.id = (Date.now() + Math.random()).toString();
                }
                if (binding.value.order === undefined) {
                    binding.value.order = 0;
                }

                el.style.cursor = vnode.context.editMode ? 'move' : 'default';

                el.onmousedown = function (e) {
                    if (!vnode.context.editMode) return;

                    if (e.target.classList.contains('remove-btn') ||
                        e.target.classList.contains('edit-btn-elements')) {
                        return;
                    }
                    e.preventDefault();
                    const container = el.parentElement;
                    const containerRect = container.getBoundingClientRect();
                    const elRect = el.getBoundingClientRect();
                    let startLeft = el.offsetLeft;
                    let startTop = el.offsetTop;
                    let startX = e.clientX;
                    let startY = e.clientY;

                    const onMouseMove = function (e) {
                        const dx = e.clientX - startX;
                        const dy = e.clientY - startY;
                        let newLeft = startLeft + dx;
                        let newTop = startTop + dy;
                        const maxLeft = containerRect.width - elRect.width - GRID_SIZE;
                        newLeft = Math.max(0, Math.min(maxLeft, newLeft));
                        newLeft = Math.round(newLeft / GRID_SIZE) * GRID_SIZE;
                        newTop = Math.round(newTop / GRID_SIZE) * GRID_SIZE;
                        el.style.left = `${newLeft}px`;
                        el.style.top = `${newTop}px`;
                    };

                    const onMouseUp = function () {
                        document.removeEventListener('mousemove', onMouseMove);
                        document.removeEventListener('mouseup', onMouseUp);
                        const finalLeft = Math.round(el.offsetLeft / GRID_SIZE) * GRID_SIZE;
                        const finalTop = Math.round(el.offsetTop / GRID_SIZE) * GRID_SIZE;
                        el.style.left = `${finalLeft}px`;
                        el.style.top = `${finalTop}px`;

                        const newPosition = { left: finalLeft, top: finalTop };
                        binding.value.position = newPosition;

                        const elementIndex = vnode.context.elements.findIndex(e => e.id === binding.value.id);
                        if (elementIndex !== -1) {
                            const updatedElement = { ...vnode.context.elements[elementIndex], position: newPosition };
                            vnode.context.$set(vnode.context.elements, elementIndex, updatedElement);
                        }

                        if (!binding.value.id) {
                            binding.value.id = (Date.now() + Math.random()).toString();
                        }
                        if (binding.value.order === undefined) {
                            binding.value.order = 0;
                        }

                        const elementCopy = JSON.parse(JSON.stringify(binding.value));
                        const dragEndEvent = new CustomEvent('drag-end', {
                            detail: { element: elementCopy },
                            bubbles: true
                        });
                        el.dispatchEvent(dragEndEvent);
                    };

                    document.addEventListener('mousemove', onMouseMove);
                    document.addEventListener('mouseup', onMouseUp);
                };
            }
        },
        resizable: {
            inserted(el, binding, vnode) {
                if (getComputedStyle(el).position === 'static') {
                    el.style.position = 'relative';
                }

                const resizeHandle = document.createElement('div');
                resizeHandle.className = 'resize-handle';
                resizeHandle.style.width = '18px';
                resizeHandle.style.height = '18px';
                resizeHandle.style.position = 'absolute';
                resizeHandle.style.right = '0';       // ou '-3px', etc.
                resizeHandle.style.bottom = '0';      // ou '2px'
                resizeHandle.style.cursor = 'se-resize';
                resizeHandle.style.backgroundColor = 'transparent';
                resizeHandle.style.borderRight = '4px solid rgb(232, 89, 51)';
                resizeHandle.style.borderBottom = '4px solid rgb(232, 89, 51)';
                resizeHandle.style.borderRadius = '0 0 4px 0';
                resizeHandle.style.zIndex = '10';
                resizeHandle.style.display = vnode.context.editMode ? 'block' : 'none';

                el.appendChild(resizeHandle);

                resizeHandle.addEventListener('mousedown', function (e) {
                    if (!vnode.context.editMode) return;
                    e.preventDefault();
                    e.stopPropagation();

                    const startX = e.clientX;
                    const startY = e.clientY;
                    const style = window.getComputedStyle(el);
                    const startWidth = parseInt(style.width, 10);
                    const startHeight = parseInt(style.height, 10);

                    function doResize(ev) {
                        const dx = ev.clientX - startX;
                        const dy = ev.clientY - startY;

                        if (binding.value.type === 'chart') {
                            const newWidth = Math.max(50, startWidth + dx);
                            const newHeight = Math.max(50, startHeight + dy);
                            el.style.width = newWidth + 'px';
                            el.style.height = newHeight + 'px';
                        } else {
                            const newWidth = Math.max(50, startWidth + dx);
                            el.style.width = newWidth + 'px';
                            el.style.height = startHeight + 'px';
                        }
                    }

                    function stopResize() {
                        document.removeEventListener('mousemove', doResize);
                        document.removeEventListener('mouseup', stopResize);

                        const finalWidth = parseInt(el.style.width, 10);
                        const finalHeight = parseInt(el.style.height, 10);

                        if (binding.value.type === 'chart') {
                            binding.value.width = finalWidth;
                            binding.value.height = finalHeight;
                        } else {
                            binding.value.width = finalWidth;
                        }

                        const elementIndex = vnode.context.elements.findIndex(
                            item => item.id === binding.value.id
                        );
                        if (elementIndex !== -1) {
                            const updatedElement = { ...vnode.context.elements[elementIndex] };
                            updatedElement.width = finalWidth;
                            if (binding.value.type === 'chart') {
                                updatedElement.height = finalHeight;
                            }
                            vnode.context.$set(vnode.context.elements, elementIndex, updatedElement);
                        }

                        const elementCopy = JSON.parse(JSON.stringify(binding.value));
                        const resizeEndEvent = new CustomEvent('resize-end', {
                            detail: { element: elementCopy },
                            bubbles: true
                        });
                        el.dispatchEvent(resizeEndEvent);

                        if (
                            binding.value.type === 'chart' &&
                            vnode.context.$refs.myChart
                        ) {
                            vnode.context.$nextTick(() => {
                                if (Array.isArray(vnode.context.$refs.myChart)) {
                                    vnode.context.$refs.myChart.forEach(chart => chart.resize());
                                } else {
                                    vnode.context.$refs.myChart.resize();
                                }
                            });
                        }
                    }

                    document.addEventListener('mousemove', doResize);
                    document.addEventListener('mouseup', stopResize);
                });
            },

            update(el, binding, vnode) {
                const resizeHandle = el.querySelector('.resize-handle');
                if (resizeHandle) {
                    resizeHandle.style.display = vnode.context.editMode ? 'block' : 'none';
                }
            }
        },
        focus: {
            inserted(el) { el.focus(); }
        }
    },
    components: { searchDatePicker, HeaderModal, TextBoxModal, BlueOptModal, OrangeOptModal, GoalModal, TableOccurrenceModal, ChartSelectionModal, ChartMetaConfigModal, 'v-chart': ECharts, ChartBarConfigModal, WhatsAppUserModal, TurnoMetaModal, SendHistoryModal, SendConfigModal, RelatoTurnoModal, MetaPlanoModal },
    data() {
        return {
            loading: true,
            loadingMessageIndex: 0,
            loadingMessages: [
                "Carregando Ocorrências...",
                "Carregando Telas e Áreas...",
                "Carregando Relatos...",
                "Carregando informações dos gráficos...",
                "Carregando informações do Modelo de Relatório...",
                "Carregando informações de Exportação...",
                "Carregando informações do Dia selecionado...",
                "Carregando Informações dos Indicadores..."
            ],
            intervalId: null,
            reportModels: [],
            reportTemplateName: "",
            isDefaultReport: false,
            newModelName: "",
            chartBarConfig: { selectedCategory: "geral", selectedTela: "", selectedArea: "", orientation: "barras", rangeStart: 0, rangeEnd: 0, ocorrenciasTipo: "abertas" },
            showChartBarConfigModal: false,
            screensAreas: {},
            tableOccurrenceForm: null,
            currentOccurrenceIndex: null,
            workshiftData: [],
            currentWorkShift: null,
            selectedDate: null,
            ptbr: ptBR,
            elements: [],
            reportFound: false,
            editMode: false,
            exportSpace: false,
            indicatorData: [],
            triggersData: [],
            indicators: [],
            showBlueModal: false,
            showOrangeModal: false,
            showMetaModal: false,
            showTextModal: false,
            showGraphModal: false,
            showChartMetaConfigModal: false,
            currentChartIndex: null,
            chartMetaConfig: { indicator: null, metaValue: "" },
            headerForm: { elementIndex: null, text: "", color: "#808080" },
            textForm: { content: "", color: "#000" },
            colorOptions: [
                { value: "#000000", label: "Preto" },
                { value: "#26806c", label: "Verde" },
                { value: "#70297A", label: "Roxo" },
                { value: "#254E70", label: "Azul" },
                { value: "#808080", label: "Cinza" },
                { value: "#bf0603", label: "Vermelho" },
                { value: "#f6ae2d", label: "Amarelo" },
                { value: "#e85933", label: "Laranja" }
            ],
            currentTableIndex: null,
            currentRowIndex: null,
            currentColIndex: null,
            blueModalForm: { selectedOption: "indicadorPGDI", productionIndicator: "Moagem (ton)" },
            orangeOptions: [],
            metaSettings: [],
            currentMetaTableIndex: null,
            currentMetaColIndex: null,
            showMetaPlanoModal: false,
            currentMetaPlanoTableIndex: null,
            currentMetaPlanoRowIndex: null,
            currentMetaPlanoColIndex: null,
            currentMetaPlanoEquation: '',
            currentMetaPlanoComment: '',
            currentMetaPlanoIndicator: '',
            chartOptions: [
                { type: "velocimetro", label: "Gráfico de velocímetro", img: require("@/assets/velocimetro.png") },
                { type: "barras", label: "Gráfico de Barras", img: require("@/assets/barras.png") },
                { type: "barrasDeitadas", label: "Gráfico de Barras deitadas", img: require("@/assets/barras-deitadas.png") },
                { type: "ocorrencias", label: "Relatório de ocorrências", img: require("@/assets/ocorrencias.png") }
            ],
            chartImages: {
                velocimetro: require("@/assets/velocimetro.png"),
                barras: require("@/assets/barras.png"),
                linhas: require("@/assets/linhas.png"),
                pizza: require("@/assets/pizza.png"),
                barrasDeitadas: require("@/assets/barras-deitadas.png"),
                ocorrencias: require("@/assets/ocorrencias.png")
            },
            shortcuts: [],
            src: null,
            loadingModels: false,
            showWhatsAppModal: false,
            availableUsers: [],
            whatsappUsersData: [],
            preSelectedWhatsAppUsers: [],
            currentTurnoMeta: "",
            turnoMetaItems: [],
            currentMetaValue: "",
            sendCount: 0,
            sendLimit: 4,
            sendMode: "manual",
            currentRelatoEditData: null,
            currentRelatoIndex: null,
            closingWorkshift: [], // estado legado — usado exclusivamente por fetchMockPgdiData (GetClosingInfos), sem binding na UI do relatório customizado
            shiftReportRelatos: [],
            pgdiMetrics: {},
            shiftReportProducao: [],
            shiftReportManutencao: [],
            shiftReportMoagem: []
        };
    },

    methods: {
        async syncSelectedDateWithBusinessDay() {
            try {
                const { data } = await axios.get(`${urlMainAPI}/basedate`);
                const baseDateStr = data?.date ?? data;

                if (typeof baseDateStr === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(baseDateStr)) {
                    const [y, m, d] = baseDateStr.split('-').map(Number);
                    this.selectedDate = new Date(y, m - 1, d);
                } else {
                    this.selectedDate = new Date(); 
                }
            } catch (err) {
                this.openToast('Erro ao buscar data de negócio. Usando data atual.', 'Erro', 'danger');
                this.selectedDate = new Date();
            }
        },

        async enterModelEditMode() {
            if (!this.reportTemplateName) return;

            this.openToast("Entrando no modo de Edição do Modelo...", "Sucesso", "success");
            this.editMode = true;

            await this.fetchReportModels();
            this.loadingModels = false;

            const defaultModel = this.reportModels.find(m => m.Name === this.reportTemplateName);
            this.isDefaultReport = defaultModel ? defaultModel.IsDefault : false;

            await this.getReportByName(this.reportTemplateName, true);
            this.updateOccurrenceTables();
            await this.renderReport();
        },

        sortSeriesAsc(cats, vals) {
            if (!Array.isArray(cats) || !Array.isArray(vals) || cats.length !== vals.length) {
                return [[], []];
            }

            const pairs = cats
                .map((c, i) => ({ c, v: vals[i] }))
                .filter(p => p.v != null && !isNaN(p.v) && p.v !== -9999)
                .sort((a, b) => a.v - b.v);

            return [pairs.map(p => p.c), pairs.map(p => p.v)];
        },

        adjustPositions() {
            const container = this.$refs.reportContainer
            const els = this.sortedElements
            const GAP = 1

            els.forEach(element => {
                const curr = container.querySelector(`[data-id="${element.id}"]`)
                if (!curr) return

                let maxBottom = 0
                els
                    .filter(prev => prev.order < element.order)
                    .forEach(prev => {
                        const prevEl = container.querySelector(`[data-id="${prev.id}"]`)
                        if (!prevEl) return

                        const currLeft = curr.offsetLeft
                        const currRight = curr.offsetLeft + curr.offsetWidth
                        const prevLeft = prevEl.offsetLeft
                        const prevRight = prevEl.offsetLeft + prevEl.offsetWidth

                        const overlapX = currLeft < prevRight && prevLeft < currRight
                        if (overlapX) {
                            const bottom = prevEl.offsetTop + prevEl.offsetHeight
                            if (bottom > maxBottom) {
                                maxBottom = bottom
                            }
                        }
                    })

                if (maxBottom > 0) {
                    const newTop = maxBottom + GAP
                    element.position.top = newTop
                    curr.style.top = newTop + 'px'
                }
            })
        },
        
        startEditModelName(model) {
            this.reportModels.forEach(m => this.$set(m, 'editing', false));
            this.$set(model, 'editing', true);
            this.$set(model, 'editedName', model.Name);
            this.$set(model, 'NameBeforeEdit', model.Name);
        },

        cancelEditModelName(model) {
            this.$set(model, 'editing', false);
        },

        async confirmEditModelName(model) {
            const newName = model.editedName.trim();
            if (!newName || newName === model.Name) {
                model.editing = false;
                return;
            }

            const nameExists = this.reportModels.some(m =>
                m.Id !== model.Id && m.Name.toLowerCase() === newName.toLowerCase()
            );

            if (nameExists) {
                this.openToast("Já existe um modelo com esse nome", "Atenção", "warning");
                return;
            }

            if (this.reportTemplateName === model.NameBeforeEdit) {
                this.reportTemplateName = newName;
            }

            try {
                await this.updateModelName(model, newName);
                model.editing = false;
            } catch (error) {
                console.error("Erro ao atualizar nome:", error);
            }
        },

        startLoadingSequence() {
            this.intervalId = setInterval(() => {
                if (this.loadingMessageIndex < this.loadingMessages.length - 1) {
                    this.loadingMessageIndex++;
                }
            }, 15000);
        },

        async openReportModelsModal() {
            await this.fetchReportModels();
            this.$bvModal.show("reportModelsModal");
        },
        async fetchReportModels() {
            this.loading = true;
            this.loadingModels = true;
            try {
                const response = await axios.get(`${urlMainAPI}/getallreports`);
                if (response.data && Array.isArray(response.data)) {
                    this.reportModels = response.data.sort((a, b) => a.Id - b.Id);
                    this.openToast("Modelos carregados com sucesso", "Sucesso", "success");
                } else {
                    this.reportModels = [];
                    this.openToast("Nenhum modelo encontrado", "Atenção", "warning");
                }
            } catch (error) {
                this.openToast("Erro ao buscar modelos: " + error, "Erro", "danger");
            } finally {
                this.loadingModels = false;
                this.loading = false;
            }
        },
        openNewModelModal() {
            this.newModelName = "";
            this.isDefaultReport = false;
            this.$bvModal.show("newModelModal");
        },
        closeNewModelModal() {
            this.$bvModal.hide("newModelModal");
            this.newModelName = "";
            this.isDefaultReport = false;
        },
        confirmNewModel() {
            if (this.newModelName.trim() !== "") {
                this.reportTemplateName = this.newModelName;
                this.addNewReportModel();
                this.newModelName = "";
                this.$bvModal.hide("newModelModal");
            } else {
                this.openToast("Por favor, insira um nome para o modelo", "Atenção", "warning");
            }
        },
        addNewReportModel() {
            this.reportModelsModalClosed = true;
            this.elements = [];
            this.editMode = true;
            this.$bvModal.hide("reportModelsModal");
            this.openToast("Modo de criação ativado", "Sucesso", "success");
        },
        async editReportModel(model) {
            this.$bvModal.hide("reportModelsModal");
            await this.getReportByName(model.Name, true);
            this.updateOccurrenceTables();
            // await this.renderReport();
            this.isDefaultReport = model.IsDefault;
            this.editMode = true;
            this.openToast("Carregando modelo para edição", "Editar", "success");
        },
        async setDefaultModel(model) {
            this.loadingModels = true;
            try {
                const response = await axios.get(`${urlMainAPI}/setdefaultreport/${model.Id}`);
                if (response.data.success) {
                    this.reportModels = this.reportModels.map(m => ({
                        ...m,
                        IsDefault: m.Id === model.Id
                    }));
                    this.openToast("Modelo definido como padrão", "Sucesso", "success");
                }
            } catch (error) {
                this.openToast("Erro ao definir modelo padrão: " + error, "Erro", "danger");
            } finally {
                await this.fetchReportModels();
                this.loadingModels = false;
            }
        },

        async updateModelName(model, newName) {
            try {
                const response = await axios.get(`${urlMainAPI}/updatereportname/${model.Id}/${encodeURIComponent(newName)}`);
                if (response.data.success) {
                    this.openToast("Nome atualizado com sucesso", "Sucesso", "success");
                }

                await this.fetchReportModels();
            } catch (error) {
                if (error.response?.status === 409) {
                    this.openToast("Já existe um modelo com esse nome", "Erro", "danger");
                } else {
                    this.openToast("Erro ao atualizar nome do modelo: " + error, "Erro", "danger");
                }
            }
        },

        async removeReportModel(model, index) {
            this.loadingModels = true;
            try {
                const response = await axios.get(`${urlMainAPI}/removereport/${model.Id}`);
                if (response.data.success) {
                    this.reportModels.splice(index, 1);
                    this.openToast("Modelo removido com sucesso", "Sucesso", "success");
                }
            } catch (error) {
                this.openToast("Erro ao remover modelo: " + error, "Erro", "danger");
            } finally {
                await this.fetchReportModels();
                this.loadingModels = false;
            }
        },

        computeChartBarOption(config) {
            const {
                orientation,
                rangeStart,
                rangeEnd,
                selectedCategory,
                selectedTela,
                selectedArea,
                chartWidth = 450,
                chartHeight = 200,
                chartLeft,
                chartRight,
                chartTop,
                chartBottom,
                ocorrenciasTipo
            } = config;

            const start = Number(rangeStart);
            const end = Number(rangeEnd);
            const isHorizontal = orientation === 'barras';
            const SENTINEL = -9999;

            if (this.pgdiMetrics) {


                const currentGroup = selectedTela || this.pgdiMetrics.screens?.[0];
                const groupCharts = this.pgdiMetrics.groups?.[currentGroup]?.charts;
                const groupOcc = this.occurrences.Chart?.[selectedTela];

                const getBarColor = value => {
                    if (isNaN(value)) return '#009A9A';
                    if (value < start) return '#C21C1B';
                    if (value <= end) return '#EAB308';
                    return '#009A9A';
                };

                const buildGrid = () => ({
                    left: isHorizontal ? (chartLeft ?? 60) : (chartLeft ?? 10),
                    right: chartRight ?? 40,
                    top: chartTop ?? 50,
                    bottom: isHorizontal ? (chartBottom ?? 30) : (chartBottom ?? 80),
                    containLabel: true
                });

                const buildTooltip = () => ({
                    trigger: selectedCategory === 'porArea' ? 'item' : 'axis',
                    formatter: params => {
                        if (Array.isArray(params)) {
                            let s = `${params[0].axisValue}<br/>`;
                            params.forEach(p => {
                                if (p.value != null) {
                                    s += `${p.marker} ${p.seriesName}: ${p.value.toFixed(2)}%<br/>`;
                                }
                            });
                            return s;
                        }
                        return `${params.name}: ${params.value.toFixed(2)}%`;
                    }
                });

                const buildBaseVisualMap = () => ({
                    type: 'piecewise',
                    orient: 'horizontal',
                    left: 'center',
                    bottom: isHorizontal ? 15 : 20,
                    pieces: [
                        { lt: start, label: `< ${start}%`, color: '#C21C1B' },
                        { gte: start, lte: end, label: `${start}-${end}%`, color: '#EAB308' },
                        { gt: end, label: `> ${end}%`, color: '#009A9A' }
                    ],
                    textStyle: { fontSize: 12 },
                    calculable: false,
                    selectedMode: false
                });

                const grid = buildGrid();
                const tooltip = buildTooltip();
                const visualMap = buildBaseVisualMap();

                // 3) Builders por categoria
                const buildGeral = () => {
                    const data = groupCharts?.geral;
                    if (!data) {
                        return {
                            title: { text: `Aderência Geral (${currentGroup})`, left: 'center', top: 10 },
                            series: [{ name: 'Aderência', type: 'bar', data: [{ value: [], itemStyle: { color: '#009A9A' } }] }],
                            tooltip, visualMap,
                            legend: { show: false },
                            xAxis: { type: 'value' },
                            yAxis: { type: 'category', data: [] }
                        };
                    }

                    const items = data.values.map(v => {
                        const val = v === SENTINEL ? null : Number(v.toFixed(2));
                        return { value: val, itemStyle: { color: getBarColor(val) } };
                    });

                    return {
                        title: { text: `Aderência Geral (${currentGroup})`, left: 'center', top: 10 },
                        tooltip, visualMap, legend: { show: false },
                        grid: { ...grid, top: 60, bottom: 60 },
                        xAxis: isHorizontal
                            ? { type: 'category', data: data.categories, axisLabel: { fontSize: 12 } }
                            : { type: 'value', axisLabel: { formatter: '{value}' } },
                        yAxis: isHorizontal
                            ? { type: 'value', axisLabel: { formatter: '{value}' } }
                            : { type: 'category', data: data.categories, axisLabel: { fontSize: 12 } },
                        series: [{
                            name: 'Aderência',
                            type: 'bar',
                            label: {
                                show: true,
                                position: isHorizontal ? 'top' : 'right',
                                formatter: p => `${p.value.toFixed(2)}%`,
                                distance: isHorizontal ? 5 : 0,
                                fontSize: 12
                            },
                            data: items
                        }],
                        chartWidth, chartHeight
                    };
                };

                const buildPorTela = () => {
                    const raw = groupCharts?.porTela?.groupedValues;
                    if (!raw) return { title: { text: `Tela: ${selectedTela || 'Todas'}` }, series: [], xAxis: {}, yAxis: {} };

                    const areas = Object.keys(raw);
                    const turnos = areas.length ? Object.keys(raw[areas[0]]) : [];

                    const sortedAreas = areas;

                    const turnoColors = ['#606062', '#85007d', '#64B5F6'];
                    const vmTurnos = {
                        type: 'piecewise', orient: 'horizontal', left: 'center', top: isHorizontal ? 30 : 40, itemGap: 15,
                        pieces: turnos.map((t, i) => ({ value: t, label: t, color: turnoColors[i] })),
                        textStyle: {
                            fontSize: 12,
                            rich: turnos.reduce((m, t, i) => { m[t] = { color: turnoColors[i] }; return m; }, {})
                        },
                        formatter: n => `{${n}|${n}}`,
                        calculable: false, selectedMode: false
                    };

                    const series = turnos.map((t, i) => ({
                        name: t,
                        type: 'bar',
                        barGap: isHorizontal ? '30%' : '60%',
                        label: {
                            show: true,
                            position: isHorizontal ? 'top' : 'right',
                            formatter: p => `${p.value.toFixed(2)}`,
                            distance: isHorizontal ? 5 : 2,
                            fontSize: 12,
                            fontWeight: 'bold',
                            color: turnoColors[i]
                        },
                        data: sortedAreas.map(area => {
                            const rawV = Number(raw[area][t]);
                            const val = rawV === SENTINEL ? null : Number(rawV.toFixed(2));
                            return { value: val, itemStyle: { color: getBarColor(val) } };
                        })
                    }));

                    const xAxis = isHorizontal
                        ? {
                            type: 'category',
                            data: sortedAreas,
                            axisLabel: {
                                interval: 0, rotate: 45,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            }
                        }
                        : {
                            type: 'value', axisLabel: { formatter: '{value}%' },
                            splitLine: { show: true, lineStyle: { type: 'dashed' } }
                        };

                    const yAxis = isHorizontal
                        ? { type: 'value', axisLabel: { formatter: '{value}%' }, splitLine: { show: true, lineStyle: { type: 'dashed' } } }
                        : {
                            type: 'category',
                            data: sortedAreas,
                            axisLabel: {
                                interval: 0, rotate: 45,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            }
                        };

                    return {
                        title: { text: `Tela: ${selectedTela || 'Todas'}`, left: 'center', top: 10 },
                        tooltip,
                        visualMap: [visualMap, vmTurnos],
                        grid: { ...grid, top: 80, containLabel: true },
                        xAxis, yAxis, series, chartWidth, chartHeight
                    };
                };

                const buildPorArea = () => {
                    const raw = groupCharts?.porArea?.groupedValues;
                    if (!raw) return { series: [], xAxis: {}, yAxis: {} };

                    const key = Object.keys(raw).find(k =>
                        k.trim().toLowerCase() === selectedArea.trim().toLowerCase()
                    );
                    if (!key) return { series: [], xAxis: {}, yAxis: {} };

                    let inds = Object.keys(raw[key]);
                    let vals = inds.map(ind => {
                        const r = Number(raw[key][ind]);
                        return r === SENTINEL ? null : Number(r.toFixed(2));
                    });
                    [inds, vals] = this.sortSeriesAsc(inds, vals);

                    const data = vals.map(v => ({ value: v, itemStyle: { color: getBarColor(v) } }));

                    const xAxis = isHorizontal
                        ? {
                            type: 'category',
                            data: inds,
                            axisLabel: {
                                interval: 0, rotate: 45,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            }
                        }
                        : {
                            type: 'value', axisLabel: { formatter: '{value}%' },
                            splitLine: { show: true, lineStyle: { type: 'dashed' } }
                        };

                    const yAxis = isHorizontal
                        ? {
                            type: 'value', axisLabel: { formatter: '{value}%' },
                            splitLine: { show: true, lineStyle: { type: 'dashed' } }
                        }
                        : { type: 'category', data: inds, axisTick: { alignWithLabel: true } };

                    return {
                        title: { text: `Área: ${selectedArea}`, left: 'center', top: 10 },
                        tooltip, visualMap, legend: { show: false },
                        grid: { ...grid, top: 50, containLabel: true },
                        xAxis, yAxis,
                        series: [{
                            name: key, type: 'bar',
                            label: {
                                show: true,
                                position: isHorizontal ? 'top' : 'inside',
                                formatter: p => p.value == null ? '' : `${p.value.toFixed(2)}%`,
                                distance: isHorizontal ? 5 : 2,
                                color: isHorizontal ? undefined : '#fff',
                                fontSize: 12,
                                fontWeight: 500
                            },
                            data
                        }],
                        chartWidth, chartHeight
                    };
                };

                const buildOcorrenciasTotais = () => {
                    if (!groupOcc) return { series: [], xAxis: {}, yAxis: {} };

                    const raw = ocorrenciasTipo === 'abertas' ? groupOcc.Opened : groupOcc.Closed;
                    let areas = Object.keys(raw);
                    const turnos = areas.length ? Object.keys(raw[areas[0]]).filter(t => t !== 'Dia') : [];

                    const colors = ['#606062', '#85007d', '#64B5F6'];
                    const vmT = {
                        type: 'piecewise', orient: 'horizontal', left: 'center',
                        top: isHorizontal ? 30 : 40, itemGap: 15,
                        pieces: turnos.map((t, i) => ({ value: t, label: t, color: colors[i] })),
                        textStyle: {
                            fontSize: 12,
                            rich: turnos.reduce((m, t, i) => { m[t] = { color: colors[i] }; return m; }, {})
                        },
                        formatter: n => `{${n}|${n}}`, calculable: false, selectedMode: false
                    };

                    const series = turnos.map((t, i) => ({
                        name: t,
                        type: 'bar',
                        barGap: isHorizontal ? '30%' : '60%',
                        label: {
                            show: true,
                            position: isHorizontal ? 'top' : 'right',
                            formatter: p => `${p.value}`,
                            distance: isHorizontal ? 5 : 2,
                            fontSize: 12,
                            fontWeight: 'bold',
                            color: colors[i]
                        },
                        data: areas.map(a => {
                            const r = Number(raw[a][t]);
                            const v = r === SENTINEL ? null : Number(r.toFixed(2));
                            return { value: v, itemStyle: { color: colors[i] } };
                        })
                    }));

                    const xAxis = isHorizontal
                        ? {
                            type: 'category', data: areas,
                            axisLabel: {
                                interval: 0, rotate: 45,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            },
                            axisTick: { alignWithLabel: true }
                        }
                        : { type: 'value', splitLine: { show: true, lineStyle: { type: 'dashed' } } };

                    const yAxis = isHorizontal
                        ? { type: 'value', splitLine: { show: true, lineStyle: { type: 'dashed' } } }
                        : {
                            type: 'category',
                            data: areas,
                            axisLabel: {
                                interval: 0,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            }
                        };

                    return {
                        title: { text: `Ocorrências ${ocorrenciasTipo === 'abertas' ? 'Abertas' : 'Fechadas'} (${selectedTela})`, left: 'center', top: 10 },
                        tooltip: { trigger: 'axis' },
                        visualMap: [vmT],
                        grid: { ...grid, top: 80, containLabel: true },
                        xAxis, yAxis, series, chartWidth, chartHeight
                    };
                };

                const buildOcorrenciasTratadas = () => {
                    if (!groupOcc) return { series: [], xAxis: {}, yAxis: {} };

                    const raw = groupOcc.ClosedPercentage;
                    let areas = Object.keys(raw);
                    const turnos = areas.length ? Object.keys(raw[areas[0]]).filter(t => t !== 'Dia') : [];

                    const colors = ['#606062', '#85007d', '#64B5F6'];
                    const vmT = {
                        type: 'piecewise', orient: 'horizontal', left: 'center',
                        top: isHorizontal ? 30 : 40, itemGap: 15,
                        pieces: turnos.map((t, i) => ({ value: t, label: t, color: colors[i] })),
                        textStyle: {
                            fontSize: 12,
                            rich: turnos.reduce((m, t, i) => { m[t] = { color: colors[i] }; return m; }, {})
                        },
                        formatter: n => `{${n}|${n}}`, calculable: false, selectedMode: false
                    };

                    const series = turnos.map((t, i) => ({
                        name: t,
                        type: 'bar',
                        barGap: isHorizontal ? '30%' : '60%',
                        label: {
                            show: true,
                            position: isHorizontal ? 'top' : 'right',
                            formatter: p => `${p.value}`,
                            distance: isHorizontal ? 5 : 2,
                            fontSize: 12,
                            fontWeight: 'bold',
                            color: colors[i]
                        },
                        data: areas.map(a => {
                            const r = Number(raw[a][t]);
                            const v = r === SENTINEL ? null : Number(r.toFixed(2));
                            return { value: v, itemStyle: { color: getBarColor(v) } };
                        })
                    }));

                    const xAxis = isHorizontal
                        ? {
                            type: 'category', data: areas,
                            axisLabel: {
                                interval: 0, rotate: 45,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            },
                            axisTick: { alignWithLabel: true }
                        }
                        : { type: 'value', splitLine: { show: true, lineStyle: { type: 'dashed' } } };

                    const yAxis = isHorizontal
                        ? { type: 'value', splitLine: { show: true, lineStyle: { type: 'dashed' } } }
                        : {
                            type: 'category',
                            data: areas,
                            axisLabel: {
                                interval: 0,
                                formatter: v => v.length > 20 ? v.match(/.{1,20}/g).join('\n') : v
                            }
                        };

                    return {
                        title: { text: `Ocorrências Tratadas (%) (${selectedTela})`, left: 'center', top: 10 },
                        tooltip: { trigger: 'axis' },
                        visualMap: [visualMap, vmT],
                        grid: { ...grid, top: 80, containLabel: true },
                        xAxis, yAxis, series, chartWidth, chartHeight
                    };
                };

                const buildFechamentoGeral = () => {
                    if (!groupOcc) {
                        return {
                            title: { text: `Fechamento Geral de Ocorrências (${selectedTela})`, left: 'center', top: 10 },
                            series: [{ type: 'bar', data: [] }],
                            tooltip, visualMap,
                            legend: { show: false },
                            xAxis: { type: 'value' },
                            yAxis: { type: 'category', data: [] }
                        };
                    }

                    const turnos = Object.keys(groupOcc.OverallPercentage || {}).filter(t => t !== 'Dia');

                    // 4) monta os itens já ordenados
                    const items = turnos.map(t => {
                        const v = Number(groupOcc.OverallPercentage[t]);
                        return {
                            value: Number(v.toFixed(2)),
                            itemStyle: { color: getBarColor(v) }
                        };
                    });

                    return {
                        title: { text: `Fechamento Geral de Ocorrências (${selectedTela})`, left: 'center', top: 10 },
                        tooltip, visualMap, legend: { show: false },
                        grid: { ...grid, top: 60, bottom: 60 },
                        xAxis: isHorizontal
                            ? { type: 'category', data: turnos, axisLabel: { fontSize: 12 } }
                            : { type: 'value', axisLabel: { formatter: '{value}%' } },
                        yAxis: isHorizontal
                            ? { type: 'value', axisLabel: { formatter: '{value}%' } }
                            : { type: 'category', data: turnos, axisLabel: { fontSize: 12 } },
                        series: [{
                            name: 'Fechamento Geral',
                            type: 'bar',
                            label: {
                                show: true,
                                position: isHorizontal ? 'top' : 'right',
                                formatter: p => `${p.value.toFixed(2)}%`,
                                distance: isHorizontal ? 5 : 0,
                                fontSize: 12
                            },
                            data: items
                        }],
                        chartWidth, chartHeight
                    };
                };

                // 4) Dispatcher principal
                switch (selectedCategory) {
                    case 'geral': return buildGeral();
                    case 'porTela': return buildPorTela();
                    case 'porArea': return buildPorArea();
                    case 'ocorrenciasTotais': return buildOcorrenciasTotais();
                    case 'ocorrenciasTratadas': return buildOcorrenciasTratadas();
                    case 'fechamentoGeral': return buildFechamentoGeral();
                    default:
                        return {
                            tooltip,
                            visualMap,
                            legend: { show: false },
                            xAxis: { type: 'value' },
                            yAxis: { type: 'category', data: [''] },
                            grid,
                            series: [{ name: 'Aderência', type: 'bar', data: [{ value: null, itemStyle: { color: '#009A9A' } }] }],
                            chartWidth,
                            chartHeight
                        };
                }
            }
        },
        openChartBarConfigModal(index) {
            this.currentChartIndex = index;
            const currentChart = this.elements[index];
            this.chartBarConfig = currentChart.chartBarrasConfig
                ? { ...currentChart.chartBarrasConfig }
                : {
                    selectedCategory: "geral",
                    selectedTela: "",
                    selectedArea: "",
                    orientation: "barras",
                    rangeStart: 0,
                    rangeEnd: 0
                };
            this.showChartBarConfigModal = true;
        },

        closeChartBarConfigModal() {
            this.showChartBarConfigModal = false;
            this.currentChartIndex = null;
        },

        handleChartBarConfigSave(newConfig) {
            if (this.currentChartIndex !== null) {
                const el = this.elements[this.currentChartIndex];
                el.chartBarrasConfig = { ...newConfig };
                el.option = this.computeChartBarOption(newConfig);
            }
            this.closeChartBarConfigModal();
        },

        openChartEditModal(index, event) {
            event.stopPropagation();
            const element = this.$refs.reportContainer.querySelector(`[data-id="${this.elements[index].id}"]`);
            if (!element) return;

            const chart = this.elements[index];
            if (chart.chartType === 'velocimetro') {
                this.openChartMetaConfigModal(index);
            } else if (chart.chartType === 'barras' || chart.chartType === 'barrasDeitadas') {
                this.openChartBarConfigModal(index);
            } else {
                this.openToast("Tipo de gráfico ainda não suportado na edição", "Aviso", "warning");
            }
        },

        updateChartOption(index) {
            const element = this.elements[index];
            if (element && element.type === "chart" && element.dynamic) {
                if (element.metaConfig && element.metaConfig.indicator && element.metaConfig.metaValue !== "") {
                    element.option = this.computeChartOption(
                        element.metaConfig.indicator,
                        element.chartType,
                        element.mode,
                        element.metaConfig.metaValue
                    );
                } else {
                    element.option = this.createDefaultChartOption(element.chartType);
                }
            }
        },

        openChartMetaConfigModalWrapper(index, event) {
            event.stopPropagation();
            this.openChartMetaConfigModal(index);
        },

        openGraphSelectionModal() {
            this.$bvModal.show("chartSelectionModal");
        },

        closeGraphSelectionModal() {
            this.$bvModal.hide("chartSelectionModal");
        },

        handleChartSelection(selectedOption) {
            const newChart = {
                id: (Date.now() + Math.random()).toString(),
                type: "chart",
                chartType: selectedOption.type,
                dynamic: true,
                mode: "Real",
                indicator: null,
                option: this.createDefaultChartOption(selectedOption.type),
                metaConfig: { indicator: null, metaValue: "" },
                isNew: true,
                order: this.elements.length
            };

            this.elements.push(newChart);
            this.measureNew(newChart);
            this.updateElementsOrder();
            this.closeGraphSelectionModal();
        },

        computeChartOption(indicator, chartType, valueReal, metaValue) {
            if (chartType === "velocimetro") {
                const indicatorName = indicator?.indicatorName || "Açúcar";
                const unitMatch = indicatorName.match(/\(([^)]+)\)/);
                const unit = unitMatch ? unitMatch[1] : "t";

                let currentValue = parseFloat(indicator?.soma?.["Total"]);
                if (isNaN(currentValue)) {
                    currentValue = parseFloat(this.indicatorData?.[indicatorName]?.soma?.["Total"]) || 0;
                }

                const numericMeta = Number(metaValue) || 0;
                const diffPercent = numericMeta > 0 ? (currentValue / numericMeta) * 100 : 0;
                const gaugeMax = 100;
                const pointerValue = diffPercent < 0 ? 0 : diffPercent > 100 ? 100 : diffPercent;

                const colorStops = [
                    [50 / gaugeMax, "#FF0000"],
                    [75 / gaugeMax, "#ff751b"],
                    [1, "#009a9a"]
                ];

                return {
                    title: {
                        text: indicatorName,
                        left: "center",
                        top: 5,
                        textStyle: {
                            color: "#333",
                            fontSize: 14
                        }
                    },
                    tooltip: { show: false },
                    series: [
                        {
                            name: indicatorName,
                            type: "gauge",
                            startAngle: 180,
                            endAngle: 0,
                            radius: "90%",
                            center: ["50%", "60%"],
                            min: 0,
                            max: gaugeMax,
                            axisLine: {
                                lineStyle: {
                                    width: 18,
                                    color: colorStops
                                }
                            },
                            splitLine: { show: false },
                            axisTick: { show: false },
                            axisLabel: { show: false },
                            pointer: {
                                length: "70%",
                                width: 5,
                                itemStyle: {
                                    color: '#333'
                                },
                            },
                            detail: {
                                formatter: () => {
                                    const diffFormatted =
                                        numericMeta > 0 ? diffPercent.toFixed(2) + "%" : "0%";
                                    return (
                                        `\n{val|${currentValue}}{unit| ${unit}}\n` +
                                        `{labelMeta|Meta: }{meta|${numericMeta}}{unit| ${unit}}   {diff|${diffFormatted}}`
                                    );
                                },
                                offsetCenter: [0, "35%"],
                                rich: {
                                    val: { fontSize: 28, fontWeight: "bold", color: "#333" },
                                    unit: { fontSize: 14, color: "#666", padding: [0, 0, 0, 2] },
                                    labelMeta: { fontSize: 14, color: "#555" },
                                    meta: { fontSize: 14, color: "#333" },
                                    diff: {
                                        fontSize: 14,
                                        color: "#333",
                                        fontWeight: "bold",
                                        padding: [0, 0, 0, 15]
                                    }
                                }
                            },
                            data: [{ value: pointerValue, name: "" }]
                        }
                    ]
                };
            } else {
                return this.createDefaultChartOption(chartType);
            }
        },

        createDefaultChartOption(type) {
            switch (type) {
                case "pizza":
                    return {
                        tooltip: { trigger: 'item' },
                        legend: {},
                        series: [{
                            name: 'Exemplo Pizza',
                            type: 'pie',
                            radius: '40%',
                            data: [
                                { value: 33, name: 'Label 1' },
                                { value: 67, name: 'Label 2' }
                            ]
                        }]
                    };

                case "barras":
                    return {
                        tooltip: {},
                        xAxis: {
                            type: 'category',
                            data: ['Categoria 1', 'Categoria 2', 'Categoria 3']
                        },
                        yAxis: { type: 'value' },
                        series: [{
                            name: 'Exemplo Barras',
                            type: 'bar',
                            data: [10, 15, 8]
                        }]
                    };

                case "linhas":
                    return {
                        tooltip: {},
                        xAxis: {
                            type: 'category',
                            data: ['Jan', 'Fev', 'Mar']
                        },
                        yAxis: { type: 'value' },
                        series: [{
                            name: 'Exemplo Linhas',
                            type: 'line',
                            data: [20, 10, 30]
                        }]
                    };

                case "velocimetro":
                    return {
                        title: {
                            text: "Indicador (und.)",
                            left: "center",
                            top: 5,
                            textStyle: {
                                color: "#333",
                                fontSize: 14
                            }
                        },
                        tooltip: {
                            show: false
                        },
                        series: [
                            {
                                name: "Indicador (und.)",
                                type: "gauge",
                                startAngle: 180,
                                endAngle: 0,
                                radius: "90%",
                                center: ["50%", "60%"],
                                min: 0,
                                max: 100,
                                axisLine: {
                                    lineStyle: {
                                        width: 18,
                                        color: [
                                            [0.5, "#FF0000"],
                                            [0.75, "#ff751b"],
                                            [1, "#009a9a"]
                                        ]
                                    }
                                },
                                splitLine: { show: false },
                                axisTick: { show: false },
                                axisLabel: { show: false },
                                pointer: {
                                    length: "70%",
                                    width: 5,
                                    itemStyle: {
                                        color: '#333'
                                    },
                                },
                                detail: {
                                    formatter: () => {
                                        return (
                                            `{val|-}{unit| und.}\n` +
                                            `{labelMeta|Meta: }{meta|-}{unit| und.}   {diff|-%}`
                                        );
                                    },
                                    offsetCenter: [0, "35%"],
                                    rich: {
                                        val: { fontSize: 28, fontWeight: "bold", color: "#333" },
                                        unit: { fontSize: 14, color: "#666", padding: [0, 0, 0, 2] },
                                        labelMeta: { fontSize: 14, color: "#555" },
                                        meta: { fontSize: 14, color: "#333" },
                                        diff: { fontSize: 14, color: "#333", fontWeight: "bold", padding: [0, 0, 0, 15] }
                                    }
                                },
                                data: [
                                    { value: 0, name: "" }
                                ]
                            }
                        ]
                    };

                case "barrasDeitadas":
                    return {
                        tooltip: {},
                        xAxis: { type: 'value' },
                        yAxis: {
                            type: 'category',
                            data: ['Row1', 'Row2', 'Row3']
                        },
                        series: [{
                            type: 'bar',
                            data: [10, 20, 30]
                        }]
                    };

                case "ocorrencias":
                    return {
                        tooltip: {},
                        xAxis: { data: ['Oc1', 'Oc2', 'Oc3'] },
                        yAxis: {},
                        series: [{
                            name: 'Ocorrências Exemplo',
                            type: 'bar',
                            data: [3, 7, 2]
                        }]
                    };

                default:
                    return {};
            }
        },

        openChartMetaConfigModal(index) {
            if (typeof index !== 'number' || !this.elements || !this.elements[index]) {
                console.error("Índice inválido em openChartMetaConfigModal:", index);
                return;
            }
            this.currentChartIndex = index;

            const currentChart = this.elements[index];
            this.chartMetaConfig = currentChart.metaConfig
                ? { ...currentChart.metaConfig }
                : { indicator: null, metaValue: "" };

            this.showChartMetaConfigModal = true;
        },

        closeChartMetaConfigModal() {
            this.showChartMetaConfigModal = false;
            this.currentChartIndex = null;
        },

        handleChartMetaConfigSave(newConfig) {
            if (this.currentChartIndex !== null) {
                const element = this.elements[this.currentChartIndex];

                element.metaConfig = { ...newConfig };
                element.indicator = newConfig.indicator;

                element.chartGauge = {
                    chartType: "velocimetro",
                    indicator: newConfig.indicator ? newConfig.indicator.indicatorName : "",
                    goal: newConfig.metaValue
                };
                this.updateChartOption(this.currentChartIndex);
            }
            this.closeChartMetaConfigModal();
        },

        async updateElementsOrder() {
            if (!this.elements || this.elements.length === 0) return;

            this.elements.sort((a, b) => {
                if (a.position.top === b.position.top) return a.position.left - b.position.left;
                return a.position.top - b.position.top;
            });

            this.elements = this.elements.map((element, index) => ({
                ...element,
                order: index
            }));

            //await this.renderReport();
        },

        updateElementsWidth() {
            if (!this.elements || this.elements.length === 0) return;

            this.elements.forEach(el => {
                const domEl = this.$refs.reportContainer.querySelector(`[data-id="${el.id}"]`);
                if (domEl) {
                    el.width = parseInt(domEl.style.width, 10);
                }
            });

            this.elements = [...this.elements];
        },
        openToast(msg, title, variant) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                toaster: 'b-toaster-bottom-left',
                solid: true
            })
        },


        saveTableOccurrence(updatedData) {
            let element = this.elements[this.currentOccurrenceIndex];
            if (element.type === "tableOccurrence" && element.tableOccurrence) {
                element.tableOccurrence.SelectedCategory = updatedData.selectedCategory;
                element.tableOccurrence.SelectedTurno = updatedData.selectedTurno;
                element.tableOccurrence.SelectedTela = updatedData.selectedTela;
                element.tableOccurrence.SelectedArea = updatedData.selectedArea;
                this.updateOccurrenceTables();
            }
            this.$bvModal.hide("tableOccurrenceModal");
        },

        closeTableOccurrenceModal() {
            this.$bvModal.hide("tableOccurrenceModal");
        },

        addTableOccurrence() {
            const pos = { left: 40, top: this.getLastElementBottom() };
            const newOccurrenceTable = {
                id: (Date.now() + Math.random()).toString(),
                type: "tableOccurrence",
                tableOccurrence: {
                    headers: ["Indicator", "Turno", "Aderência", "Meta (Aderência)", "Realizado", "Meta", "Média Realizado", "Limite Inferior", "Limite Superior", "Motivo", "Ação"],
                    rows: [],
                    SelectedCategory: "todosIndicadores",
                    SelectedTurno: "",
                    SelectedTela: "",
                    SelectedArea: ""
                },
                position: pos,
                width: null,
                order: this.elements.length
            };
            this.elements.push(newOccurrenceTable);
            this.measureNew(newOccurrenceTable);
        },

        openEditModal(index) {
            const element = this.elements[index];
            if (element.type === "header") {
                this.headerForm = { text: element.title.text, color: element.title.color };
                this.currentHeaderIndex = index;
                this.$bvModal.show("HeaderModal");
            } else if (element.type === "text") {
                this.textForm = { content: element.text.content, color: element.text.color };
                this.currentTextIndex = index;
                this.$bvModal.show("TextBoxModal");
            } else if (element.type === "tableOccurrence") {
                this.tableOccurrenceForm = {
                    selectedCategory: element.tableOccurrence.SelectedCategory || "",
                    selectedTurno: element.tableOccurrence.SelectedTurno || "",
                    selectedTela: element.tableOccurrence.SelectedTela || "",
                    selectedArea: element.tableOccurrence.SelectedArea || ""
                };
                this.currentOccurrenceIndex = index;
                this.$bvModal.show("tableOccurrenceModal");
            } else if (element.type === 'relatoTurno') {
                this.currentRelatoIndex = index;
                this.currentRelatoEditData = {
                    title: element.title.text,
                    color: element.title.color || '#333',
                    tabs: [...element.tabs]
                };
                this.$bvModal.show('RelatoTurnoModal');
            }
        },

        removeElement(index) {
            const element = this.elements[index];
            if (!element) return;

            const elementId = element.id;
            this.elements = this.elements.filter(el => el.id !== elementId);
            this.updateElementsOrder();
        },

        formatDate(date) {
            const d = new Date(date);
            let month = "" + (d.getMonth() + 1);
            let day = "" + d.getDate();
            const year = d.getFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            return [year, month, day].join("-");
        },

        formatDateToPtBr(date) {
            const d = new Date(date);
            let month = "" + (d.getMonth() + 1);
            let day = "" + d.getDate();
            const year = d.getFullYear();
            return [day, month, year].join("/");
        },

        clearComputedValues() {
            this.elements.forEach((element, index) => {
                if (element.type === "table" && element.table && element.table.cells) {
                    this.finalizeTable(index);
                }
            });
            for (let i = this.elements.length - 1; i >= 0; i--) {
                if (this.elements[i].type === "table") {
                    if (this.elements[i].table.rows == 1 && this.elements[i].table.cols == 1)
                        this.elements.splice(i, 1);
                }
            }
        },

        async fetchWorkShift() {
            const urlWorkShift = `${urlMainAPI}/getworkshift`;
            try {
                const response = await axios.get(urlWorkShift);
                const data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                if (Array.isArray(data) && data.length > 0) {
                this.workshiftData = data;
                this.determineActiveWorkShift();
                this.updateOrangeOptions();
                } else {
                this.openToast(this.$t("workshift-return"), "Erro", "danger");
                }
            } catch (error) {
                this.openToast(this.$t("workshit-data-error") + ` ${error}`, "Erro", "danger");
            }
        },

        determineActiveWorkShift() {
            const now = new Date();
            const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
            this.currentWorkShift = null;
            for (const shift of this.workshiftData) {
                const [startH, startM, startS] = shift.start.split(":").map(Number);
                const [endH, endM, endS] = shift.end.split(":").map(Number);
                const startSeconds = startH * 3600 + startM * 60 + startS;
                const endSeconds = endH * 3600 + endM * 60 + endS;
                let active = false;
                if (startSeconds <= endSeconds) {
                    active = currentSeconds >= startSeconds && currentSeconds <= endSeconds;
                } else {
                    active = currentSeconds >= startSeconds || currentSeconds <= endSeconds;
                }
                if (active) {
                    this.currentWorkShift = shift;
                    break;
                }
            }
        },

       async getDefaultReport() {
            this.loading = true;
            try {
            const response = await axios.get(`${urlMainAPI}/getdefaultreport`);
            // lidar com string JSON em algumas respostas
            const data = typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;

            // se não houver padrão salvo
            if (!data || !data.Elements || data.Elements.length === 0) {
                this.elements = [];
                this.reportTemplateName = "";
                this.reportFound = false;
                this.openToast("Nenhum relatório padrão encontrado.", "Atenção", "warning");
                return;
            }

            // carregou padrão
            this.isDefaultReport = true;
            this.reportTemplateName = data.Name || "Modelo Padrão";
            await this.fetchMockPgdiData(this.formatDate(this.selectedDate));
            await MediatorIndicatorEditor.getProductionPlanData(this.formatDate(this.selectedDate)).catch(() => {});

            // monta elementos
            this.elements = data.Elements.map((element, idx) => {
                const position = element.position
                ? { left: Number(element.position.left), top: Number(element.position.top) }
                : { left: 40, top: 20 };

                const base = {
                id: element.id || (Date.now() + Math.random()).toString(),
                type: element.type || "header",
                title: element.title || { text: "Novo Header", color: "#808080" },
                position,
                width: element.width != null ? element.width : null,
                height: element.height != null
                    ? element.height
                    : this.getDefaultHeight(element.type),
                order: element.order != null ? element.order : idx,
                ...element
                };

                // configura charts existentes
                if (base.type === "chart") {
                // gauge / velocimetro
                const chartData = element.chart || element.chartGauge;
                if (chartData) {
                    base.chartType = chartData.chartType || "velocimetro";
                    const foundInd = this.indicators.find(x => x.indicatorName === chartData.indicator) || null;
                    base.metaConfig = { indicator: foundInd, metaValue: chartData.goal || "" };
                    base.indicator = foundInd;
                    base.option = this.computeChartOption(
                    foundInd,
                    base.chartType,
                    "Real",
                    chartData.goal || ""
                    );
                    base.dynamic = true;
                }
                // barras
                if (element.chartBarras) {
                    base.chartType = element.chartBarras.chartType || "barras";
                    base.chartBarrasConfig = { ...element.chartBarras };
                    base.option = this.computeChartBarOption(element.chartBarras);
                    base.dynamic = true;
                }
                }

                return base;
            });

            // garante option mínimo para todos os charts
            this.elements.forEach(el => {
                if (el.type === "chart" && (!el.option || Object.keys(el.option).length === 0)) {
                el.option = this.createDefaultChartOption(el.chartType || "barras");
                }
            });

            // reconstroi tabelas
            this.elements.forEach((el, tIndex) => {
                if (el.type === "table" && el.table && el.table.cells) {
                for (let r = 1; r < el.table.rows; r++) {
                    this.updateIntersectionsForRow(tIndex, r);
                }
                }
            });

            // renderiza charts na tela
            await this.renderReport();
            this.reportFound = false;
            } catch (error) {
            this.openToast("Erro ao buscar relatório padrão: " + error, "Erro", "danger");
            } finally {
            this.loading = false;
            }
        },

        async getReportByName(name, editMode = false) {
            this.loading = true;
            this.reportTemplateName = name;
            try {
            const response = await axios.get(`${urlMainAPI}/getreport/${encodeURIComponent(name)}`);
            const data = typeof response.data === 'string'
                ? JSON.parse(response.data)
                : response.data;

            // se não encontrou nenhum
            if (!data || !data.Elements || data.Elements.length === 0) {
                this.elements = [];
                this.reportFound = false;
                this.openToast(`Nenhum relatório encontrado com o nome: ${name}`, "Atenção", "warning");
                return;
            }

            // atualiza dados PGDI se não for apenas edição
            if (!editMode) {
                await this.fetchMockPgdiData(this.formatDate(this.selectedDate));
            }

            // monta elementos
            this.elements = data.Elements.map((element, idx) => {
                const position = element.position
                ? { left: Number(element.position.left), top: Number(element.position.top) }
                : { left: 40, top: 20 };

                const base = {
                id: element.id || (Date.now() + Math.random()).toString(),
                type: element.type || "header",
                position,
                width: element.width != null ? element.width : null,
                height: element.height != null
                    ? element.height
                    : this.getDefaultHeight(element.type),
                order: element.order != null ? element.order : idx,
                ...element
                };

                // configura charts existentes
                if (base.type === "chart") {
                const chartData = element.chart || element.chartGauge;
                if (chartData) {
                    base.chartType = chartData.chartType || "velocimetro";
                    const foundInd = this.indicators.find(x => x.indicatorName === chartData.indicator) || null;
                    base.metaConfig = { indicator: foundInd, metaValue: chartData.goal || "" };
                    base.indicator = foundInd;
                    base.option = this.computeChartOption(
                    foundInd,
                    base.chartType,
                    "Real",
                    chartData.goal || ""
                    );
                    base.dynamic = true;
                }
                if (element.chartBarras) {
                    base.chartType = element.chartBarras.chartType || "barras";
                    base.chartBarrasConfig = { ...element.chartBarras };
                    base.option = this.computeChartBarOption(element.chartBarras);
                    base.dynamic = true;
                }
                }

                return base;
            });

            // garante option mínimo para todos os charts
            this.elements.forEach(el => {
                if (el.type === "chart" && (!el.option || Object.keys(el.option).length === 0)) {
                el.option = this.createDefaultChartOption(el.chartType || "barras");
                }
            });

            // busca dados frescos do plano de safra para a data selecionada
            await MediatorIndicatorEditor.getProductionPlanData(this.formatDate(this.selectedDate)).catch(() => {});

            // reconstroi tabelas
            this.elements.forEach((el, tIndex) => {
                if (el.type === "table" && el.table && el.table.cells) {
                for (let r = 1; r < el.table.rows; r++) {
                    this.updateIntersectionsForRow(tIndex, r);
                }
                }
            });

            await this.renderReport();
            this.reportFound = false;
            } catch (error) {
            this.openToast("Erro ao buscar relatório " + name + ": " + error, "Erro", "danger");
            } finally {
            this.loading = false;
            }
        },

        async searchReport(option) {
            this.loading = true;
            this.startLoadingSequence();
            this.elements = [];
            this.reportFound = false;

            if (option === 'pesquisa') {
                this.openToast(this.$t('search-report'), 'Pesquisa', 'success');
                if (this.reportTemplateName?.trim()) {
                // já tem padrão salvo, recarrega ele
                await this.getReportByName(this.reportTemplateName.trim());
                } else {
                // não tem padrão, chama o padrão genérico
                await this.getDefaultReport();
                }
            }
            else if (option === 'resetar') {
                this.editMode = true;
                this.openToast(this.$t('reset-report'), 'Resetando', 'success');
                if (this.reportTemplateName) {
                await this.getReportByName(this.reportTemplateName, true);
                } else {
                await this.getDefaultReport();
                }
            }

            await this.fetchShiftReportTurnoData();
            this.updateOccurrenceTables();
            await this.renderReport();
            this.loading = false;
        },

        editReport() {
            this.openToast(this.$t("edition-mode-report"), "Sucesso", "success");
            this.searchReport('reset');
            this.editMode = true;
        },

        createReport() {
            this.openToast(this.$t("creation-mode-report"), "Sucesso", "success");
            this.editMode = true;
        },

        prepareElementsForSave() {
            const clonedElements = JSON.parse(JSON.stringify(this.elements));

            clonedElements.forEach(element => {
                if (element.height === undefined || element.height === null) {
                    element.height = this.getDefaultHeight(element.type);
                }

                if (element.type === "table" && element.table && element.table.cells) {
                    for (let r = 1; r < element.table.rows; r++) {
                        for (let c = 1; c < element.table.cols; c++) {
                            if (element.table.cells[r][c].type === "intersection") {
                                element.table.cells[r][c].value = "";
                            }
                        }
                    }
                }

                if (element.type === "tableOccurrence" && element.tableOccurrence) {
                    element.tableOccurrence.rows = [];
                }
                if (element.type === "chart") {
                    if (element.chartType === "velocimetro") {
                        const indicador = element.metaConfig?.indicator;
                        element.chartGauge = {
                            chartType: element.chartType,
                            indicator: indicador ? indicador.indicatorName : "",
                            goal: element.metaConfig?.metaValue != null
                                ? String(element.metaConfig.metaValue)
                                : ""
                        };
                    }
                    else if (element.chartType === "barras" || element.chartType === "barrasDeitadas") {
                        element.chartBarras = {
                            ...element.chartBarrasConfig,
                            chartType: element.chartType,
                            metaValue: element.chartBarrasConfig.metaValue
                        };
                    }
                }

                delete element.chart;
                delete element.chartType;
                delete element.metaConfig;
                delete element.indicator;
                delete element.option;
                delete element.dynamic;
                delete element.isNew;
                delete element.chartBarrasConfig;
            });

            return clonedElements;
        },

        async saveReport() {
            this.clearComputedValues();
            this.updateOccurrenceTables();
            this.updateElementsOrder();
            this.updateElementsWidth();

            const payload = {
                Elements: this.prepareElementsForSave(),
                Name: this.reportTemplateName,
                IsDefault: this.isDefaultReport,
            };

            const url = `${urlMainAPI}/savereport`;
            try {
                const response = await axios.post(url, payload);
                this.openToast(response.data, "Sucesso", "success");
                this.reportFound = true;

                await this.fetchReportModels();

                if (this.isDefaultReport) {
                    const justSaved = this.reportModels.find(m => m.Name === this.reportTemplateName);
                    if (justSaved) {
                        await axios.get(`${urlMainAPI}/setdefaultreport/${justSaved.Id}`);
                    }
                }

                this.editMode = false;
            } catch (error) {
                this.loading = false;
                this.openToast(this.$t("report-data-save") + ` ${error}`, "Erro", "danger");
            }
        },

        getDefaultHeight(type) {
            switch (type) {
                case 'text': return 80;
                case 'header': return 50;
                case 'goal': return 100;
                case 'opt': return 120;
                case 'blueOpt': return 120;
                case 'orangeOpt': return 120;
                default: return 100;
            }
        },

        getLastElementBottom() {
            const margin = 20;
            const container = this.$refs.reportContainer;
            let maxBottom = 0;
            if (container) {
                const children = container.querySelectorAll('.element-wrapper');
                children.forEach(child => {
                    const bottom = child.offsetTop + child.offsetHeight;
                    if (bottom > maxBottom) {
                        maxBottom = bottom;
                    }
                });
            }
            return maxBottom + margin;
        },

        nextPosition(defaultHeight = 40) {
            const GRID_SIZE = 20;
            let maxBottom = 0;
            this.elements.forEach(el => {
                if (el.position && typeof el.position.top === 'number') {
                    let height = defaultHeight;
                    if (el.type === 'header') height = 40;
                    else if (el.type === 'text') height = 80;
                    else if (el.type === 'table' || el.type === 'tableOccurrence') height = 150;
                    else if (el.type === 'chart') height = 150;
                    const bottom = el.position.top + height;
                    if (bottom > maxBottom) maxBottom = bottom;
                }
            });
            return { left: 40, top: maxBottom + GRID_SIZE };
        },

        measureNew(el) {
            this.$nextTick(() => {
                const wrapper = this.$refs.reportContainer.querySelector(`[data-id="${el.id}"]`);
                if (!wrapper) return;
                el.width = wrapper.offsetWidth;
                if (el.type === 'chart') {
                    el.height = wrapper.offsetHeight;
                }
            });
        },

        addHeader() {
            const pos = { left: 40, top: this.getLastElementBottom() };
            const novoHeader = {
                id: (Date.now() + Math.random()).toString(),
                type: "header",
                title: { text: "Novo Header", color: "#808080" },
                position: pos,
                width: null,
                height: null,
                order: this.elements.length
            };
            this.elements.push(novoHeader);
            this.measureNew(novoHeader);
        },

        convertImageToBase64(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.onload = function () {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                    resolve(dataURL);
                };
                img.onerror = error => reject(error);
                img.src = url;
            });
        },

        async loadFooterLogo() {
            const footerLogo = document.getElementById('footer-logo');
            if (footerLogo) {
                try {
                    const response = await fetch(footerLogo.src);
                    const blob = await response.blob();
                    const base64 = await this.convertBlobToBase64(blob);
                    this.src = base64;
                } catch (error) {
                    console.error('Erro ao carregar o logo do rodapé:', error);
                }
            }
        },

        async convertBlobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
            });
        },

        computeSmartCutPoints(blockRects, totalHeight, sliceH) {
            const cuts = [0];
            let currentY = 0;

            while (currentY < totalHeight) {
                const naturalCut = currentY + sliceH;

                if (naturalCut >= totalHeight) {
                    cuts.push(totalHeight);
                    break;
                }

                const intersecting = blockRects.find(b => naturalCut > b.top && naturalCut < b.bottom);

                if (!intersecting) {
                    cuts.push(naturalCut);
                    currentY = naturalCut;
                    continue;
                }

                if (intersecting.height <= sliceH) {
                    // Bloco cabe em uma página: mover corte para antes do bloco
                    const cutBefore = intersecting.top;
                    if (cutBefore > currentY) {
                        cuts.push(cutBefore);
                        currentY = cutBefore;
                    } else {
                        // Bloco já começou nesta página, cortar após o fim dele
                        cuts.push(intersecting.bottom);
                        currentY = intersecting.bottom;
                    }
                } else {
                    // Bloco maior que uma página: cortar entre linhas da tabela
                    const rowBottoms = intersecting.rowBottoms.filter(y => y > currentY && y <= naturalCut);
                    const bestY = rowBottoms.length > 0 ? rowBottoms[rowBottoms.length - 1] : naturalCut;
                    cuts.push(bestY);
                    currentY = bestY;
                }
            }

            return cuts;
        },

        async exportPDFRobot(limitMB = 15) {
            this.openToast(this.$t("export-pdf-success"), "Exportando PDF", "success");

            const MB = 1024 * 1024;
            const htmlEl = this.$refs.reportContainer;

            if (!htmlEl) 
            { 
                this.openToast(this.$t("element-notfound"), "Erro", "danger"); 
                return; 
            }

            const clone = htmlEl.cloneNode(true);
            Object.assign(clone.style, { position: "fixed", top: "-9999px", left: "-9999px" });
            document.body.appendChild(clone);

            const charts = Array.isArray(this.$refs.myChart) ? this.$refs.myChart : [this.$refs.myChart];

            clone.querySelectorAll(".v-chart").forEach((el, i) => {
                const png = charts[i]?.getDataURL({ type: "png", pixelRatio: 2, backgroundColor: "#fff" });
                if (png) { const img = new Image(); img.src = png; img.style.cssText = `width:${el.style.width};height:${el.style.height}`; el.replaceWith(img); }
            });

            await this.$nextTick();
            clone.style.width = clone.scrollWidth + "px";
            clone.style.height = clone.scrollHeight + "px";

            const baseCanvas = await html2canvas(clone, { scale: 2, scrollX: 0, scrollY: 0 });

            const pdf = new jsPDF({ orientation: "p", unit: "pt", format: "a4", compress: true, putOnlyUsedFonts: true, floatPrecision: 16 });
            const pw = pdf.internal.pageSize.getWidth();
            const ph = pdf.internal.pageSize.getHeight();
            const headerH = 90;
            const footerH = 15;
            const contentH = ph - headerH - footerH;
            const ratio = pw / baseCanvas.width;
            const sliceH = contentH / ratio;

            const cloneTop = clone.getBoundingClientRect().top;
            const blockRects = Array.from(clone.querySelectorAll('.element-wrapper')).map(el => {
                const rect = el.getBoundingClientRect();
                const top = (rect.top - cloneTop) * 2;
                const bottom = (rect.bottom - cloneTop) * 2;
                const height = bottom - top;
                let rowBottoms = [];
                if (height > sliceH) {
                    rowBottoms = Array.from(el.querySelectorAll('tr')).map(row =>
                        (row.getBoundingClientRect().bottom - cloneTop) * 2
                    );
                }
                return { top, bottom, height, rowBottoms };
            });

            document.body.removeChild(clone);

            await this.loadFooterLogo();

            const unitLogo = this.src;
            const brandLogo = await this.convertImageToBase64(pentagroBrand);
            const iconLogo = await this.convertImageToBase64(pentagroIcon);

            pdf.addImage(unitLogo, "PNG", 0, 0, 1, 1, "unitLogo", "FAST");
            pdf.addImage(brandLogo, "PNG", 1, 1, 1, 1, "brandLogo", "FAST");
            pdf.addImage(iconLogo, "PNG", 2, 2, 1, 1, "iconLogo", "FAST");

            const cutPoints = this.computeSmartCutPoints(blockRects, baseCanvas.height, sliceH);
            const pages = cutPoints.length - 1;

            let jpgQuality = 0.9;

            let blob;
            const marginL = 20;
            const marginR = 20;

            const unitSigla = this.user?.UnitName ? this.user.UnitName : "";
            
            const title = `Relatório de Turno (${this.formatDateToPtBr(this.selectedDate)}) ${unitSigla}`;
            do {
                pdf.deletePage(1);
                pdf.addPage();
                for (let p = 0; p < pages; p++) {
                    if (p) pdf.addPage();
                    pdf.addImage(unitLogo, "PNG", (pw - 110) / 2, 5, 110, 40, "unitLogo");
                    pdf.setGState(new pdf.GState({ opacity: 0.5 }));
                    const iconW = 29, iconH = 29, brandW = 58, brandH = 23;
                    const iconX = pw - marginR - iconW - 10;
                    const iconY = 10;
                    const brandX = pw - marginR - brandW;
                    const brandY = iconY + iconH + 5;
                    pdf.addImage(iconLogo, "PNG", iconX, iconY, iconW, iconH, "iconLogo");
                    pdf.addImage(brandLogo, "PNG", brandX, brandY, brandW, brandH, "brandLogo");
                    pdf.setGState(new pdf.GState({ opacity: 1 }));
                    pdf.setFontSize(14);
                    pdf.text(title, pw / 2, 77, { align: "center" });
                    const sliceStart = cutPoints[p];
                    const sliceHeight = cutPoints[p + 1] - cutPoints[p];
                    const slice = document.createElement("canvas");
                    slice.width = baseCanvas.width;
                    slice.height = sliceHeight;
                    slice.getContext("2d").drawImage(baseCanvas, 0, sliceStart, slice.width, sliceHeight, 0, 0, slice.width, sliceHeight);
                    const jpg = slice.toDataURL("image/jpeg", jpgQuality);
                    pdf.addImage(jpg, "JPEG", marginL, headerH, pw - 2 * marginL, sliceHeight * ratio);
                    pdf.setFontSize(10);
                    pdf.text(`Página ${p + 1} de ${pages}`, pw - marginR, ph - 5, { align: "right" });
                }
                blob = pdf.output("blob");
                if (blob.size / MB > limitMB) jpgQuality -= 0.05;
            } while (blob.size / MB > limitMB && jpgQuality >= 0.6);

            if (blob.size / MB > limitMB) 
            { 
                this.openToast(this.$t("element-content"), "Atenção", "warning"); 
                return; 
            }

            const pdfDataUri = pdf.output("datauristring");
            const base64Pdf = pdfDataUri.split(',')[1];
            const d = new Date(this.selectedDate);
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const year = d.getFullYear();

            const name = `Relatorio_${day}-${month}-${year}.pdf`;
            const payload =
            {
                PdfBase64: base64Pdf,
                Name: name,
                date: `${day}-${month}-${year}`,
                SenderName: this.user?.FullName ?? ''
            };

            await this.sendPDFToBack(payload);
        },

        async exportPDF(limitMB = 15) {
            this.openToast(this.$t("export-pdf-success"), "Exportando PDF", "success");

            const MB = 1024 * 1024;
            const htmlEl = this.$refs.reportContainer;
            if (!htmlEl) {
                this.openToast("Nenhum elemento encontrado", "Erro", "danger");
                return;
            }

            const clone = htmlEl.cloneNode(true);
            Object.assign(clone.style, { position: "fixed", top: "-9999px", left: "-9999px" });
            document.body.appendChild(clone);

            const charts = Array.isArray(this.$refs.myChart) ? this.$refs.myChart : [this.$refs.myChart];
            clone.querySelectorAll(".v-chart").forEach((el, i) => {
                const png = charts[i]?.getDataURL({ type: "png", pixelRatio: 2, backgroundColor: "#fff" });
                if (png) {
                    const img = new Image();
                    img.src = png;
                    img.style.cssText = `width:${el.style.width};height:${el.style.height}`;
                    el.replaceWith(img);
                }
            });

            await this.$nextTick();
            clone.style.width = clone.scrollWidth + "px";
            clone.style.height = clone.scrollHeight + "px";

            const baseCanvas = await html2canvas(clone, { scale: 2, scrollX: 0, scrollY: 0 });

            const pdf = new jsPDF({ orientation: "p", unit: "pt", format: "a4", compress: true, putOnlyUsedFonts: true, floatPrecision: 16 });
            const pw = pdf.internal.pageSize.getWidth();
            const ph = pdf.internal.pageSize.getHeight();
            const headerH = 90;
            const footerH = 15;
            const contentH = ph - headerH - footerH;
            const ratio = pw / baseCanvas.width;
            const sliceH = contentH / ratio;

            const cloneTop = clone.getBoundingClientRect().top;
            const blockRects = Array.from(clone.querySelectorAll('.element-wrapper')).map(el => {
                const rect = el.getBoundingClientRect();
                const top = (rect.top - cloneTop) * 2;
                const bottom = (rect.bottom - cloneTop) * 2;
                const height = bottom - top;
                let rowBottoms = [];
                if (height > sliceH) {
                    rowBottoms = Array.from(el.querySelectorAll('tr')).map(row =>
                        (row.getBoundingClientRect().bottom - cloneTop) * 2
                    );
                }
                return { top, bottom, height, rowBottoms };
            });

            document.body.removeChild(clone);

            await this.loadFooterLogo();
            const unitLogo = this.src;
            const brandLogo = await this.convertImageToBase64(pentagroBrand);
            const iconLogo = await this.convertImageToBase64(pentagroIcon);

            pdf.addImage(unitLogo, "PNG", 0, 0, 1, 1, "unitLogo", "FAST");
            pdf.addImage(brandLogo, "PNG", 1, 1, 1, 1, "brandLogo", "FAST");
            pdf.addImage(iconLogo, "PNG", 2, 2, 1, 1, "iconLogo", "FAST");

            const cutPoints = this.computeSmartCutPoints(blockRects, baseCanvas.height, sliceH);
            const pages = cutPoints.length - 1;

            let jpgQuality = 0.9;
            let blob;
            const marginL = 20;
            const marginR = 20;
            const unitSigla = this.user?.UnitName ? this.user.UnitName : "";
            const title = `Relatório de Turno (${this.formatDateToPtBr(this.selectedDate)}) ${unitSigla}`;

            do {
                pdf.deletePage(1);
                pdf.addPage();

                for (let p = 0; p < pages; p++) {
                    if (p) pdf.addPage();

                    if (p === 0) {
                        pdf.addImage(pentagroLogo, "PNG", 40, 14, 102, 28, "pentagroLogo");
                        pdf.setDrawColor(200, 200, 200);
                        pdf.line(40, 51, pw - 40, 51);
                        pdf.setFontSize(14);
                        pdf.setTextColor(0, 0, 0);
                        pdf.text(title, 40, 70);
                    }
                    pdf.addImage(iconLogo, "PNG", pw - 68, 14, 28, 28, "iconLogo");
                    pdf.setFontSize(10);
                    pdf.setTextColor(120);
                    pdf.text(`Página ${p + 1} de ${pages}`, pw - marginR, ph - 5, { align: "right" });

                    const sliceStart = cutPoints[p];
                    const sliceHeight = cutPoints[p + 1] - cutPoints[p];
                    const slice = document.createElement("canvas");
                    slice.width = baseCanvas.width;
                    slice.height = sliceHeight;
                    slice.getContext("2d").drawImage(baseCanvas, 0, sliceStart, slice.width, sliceHeight, 0, 0, slice.width, sliceHeight);
                    const jpg = slice.toDataURL("image/jpeg", jpgQuality);
                    pdf.addImage(jpg, "JPEG", marginL, headerH, pw - 2 * marginL, sliceHeight * ratio);

                    pdf.setFontSize(10);
                    pdf.text(`Página ${p + 1} de ${pages}`, pw - marginR, ph - 5, { align: "right" });
                }

                blob = pdf.output("blob");
                if (blob.size / MB > limitMB) jpgQuality -= 0.05;
            } while (blob.size / MB > limitMB && jpgQuality >= 0.6);

            if (blob.size / MB > limitMB) {
                this.openToast(this.$t("element-content"), "Atenção", "warning");
                return;
            }

            pdf.save(`Relatorio_${this.formatDateToPtBr(this.selectedDate)}_${unitSigla}.pdf`);
            this.openToast(this.$t("export-pdf-success-done"), "Exportando PDF", "success");
        },

        async sendPDFToBack(payload) {
            const url = `${urlMainAPI}/savereportbase64`;
            try {
                const response = await axios.post(url, payload);
                this.openToast(response.data, "Sucesso", "success");
            } catch (error) {
                this.openToast(this.$t("pdf-error") + ` ${error}`, "Erro", "danger");
            }
        },

        addTable() {
            const pos = { left: 40, top: this.getLastElementBottom() };
            const novaTabela = {
                id: (Date.now() + Math.random()).toString(),
                type: "table",
                table: this.createDefaultTable(),
                position: pos,
                width: null,
                order: this.elements.length
            };
            this.elements.push(novaTabela);
            this.measureNew(novaTabela);
        },

        createDefaultTable() {
            const rows = 8;
            const cols = 7;
            let cells = [];
            let firstRow = [];
            for (let c = 0; c < cols; c++) {
                firstRow.push(c === 0 ? { type: "empty", value: "" } : { type: "header", value: "" });
            }
            cells.push(firstRow);
            for (let r = 1; r < rows; r++) {
                let newRow = [];
                for (let c = 0; c < cols; c++) {
                    newRow.push(c === 0 ? { type: "indicator", value: "" } : { type: "intersection", value: "" });
                }
                cells.push(newRow);
            }
            return {
                rows,
                cols,
                columnHeaders: new Array(cols).fill(null),
                rowIndicators: new Array(rows).fill(null),
                cells,
                finalized: false,
                metaSettings: {},
                dataType: "media",
                optionConfirmed: false,
                isNew: true
            };
        },

        confirmOption(tableIndex) {
            const tableData = this.elements[tableIndex].table;
            if (!tableData.dataType) {
                this.openToast(this.$t("options-search"), "Atenção", "warning");
                return;
            }
            tableData.optionConfirmed = true;
            tableData.isNew = false;
        },

        openTextModal() {
            this.currentTextIndex = undefined;
            const pos = { left: 40, top: this.getLastElementBottom() };
            this.textForm = { content: "", color: "black", position: pos };
            this.$nextTick(() => {
                const editor = document.getElementById("editor");
                if (editor) {
                    editor.innerHTML = "";
                }
            });
            this.showTextModal = true;
            this.$bvModal.show('TextBoxModal');
        },

        execCmd(command, value = null) {
            document.execCommand(command, false, value);
        },

        saveRichText() {
            const editor = document.getElementById("editor");
            const content = editor ? editor.innerHTML : "";
            if (!content.trim()) {
                this.openToast(this.$t("text-warning"), "Atenção", "warning");
                return;
            }
            if (this.currentTextIndex !== undefined) {
                this.elements[this.currentTextIndex].text = { content, color: "black" };
                this.currentTextIndex = undefined;
            } else {
                const pos = { left: 40, top: this.getLastElementBottom() };
                const newText = {
                    id: (Date.now() + Math.random()).toString(),
                    type: "text",
                    text: { content, color: "black" },
                    position: pos,
                    width: null,
                    order: this.elements.length
                };
                this.elements.push(newText);
                this.measureNew(newText);
            }
            this.closeTextModal();
        },

        closeTextModal() {
            this.showTextModal = false;
            this.$bvModal.hide('TextBoxModal');
        },

        openGraphModal() {
            this.showGraphModal = true;
        },

        closeGraphModal() {
            this.showGraphModal = false;
        },

        openHeaderModal(elementIndex) {
            const element = this.elements[elementIndex];
            if (element.type !== "header") return;
            this.headerForm = { text: element.title.text, color: element.title.color };
            this.currentHeaderIndex = elementIndex;
            this.$bvModal.show("HeaderModal");
        },

        saveHeader(updatedHeader) {
            this.elements[this.currentHeaderIndex].title.text = updatedHeader.text;
            this.elements[this.currentHeaderIndex].title.color = updatedHeader.color;
            this.$bvModal.hide("HeaderModal");
        },

        closeHeaderModal() {
            this.$bvModal.hide("HeaderModal");
        },

        addRow(tableIndex) {
            const tableData = this.elements[tableIndex].table;
            for (let i = 0; i < 3; i++) {
                tableData.rows++;
                let newRow = [];
                for (let c = 0; c < tableData.cols; c++) {
                    if (c === 0) {
                        newRow.push({ type: "indicator", value: "" });
                        tableData.rowIndicators.push(null);
                    } else {
                        newRow.push({ type: "intersection", value: "" });
                    }
                }
                tableData.cells.push(newRow);
            }
        },

        addColumn(tableIndex) {
            const tableData = this.elements[tableIndex].table;
            for (let i = 0; i < 3; i++) {
                tableData.cols++;
                for (let r = 0; r < tableData.rows; r++) {
                    if (r === 0) {
                        tableData.cells[r].push({ type: "header", value: "" });
                        tableData.columnHeaders.push(null);
                    } else {
                        tableData.cells[r].push({ type: "intersection", value: "" });
                    }
                }
            }
        },

        openBlueModal(tableIndex, rowIndex) {
            this.currentTableIndex = tableIndex;
            this.currentRowIndex = rowIndex;
            const currentValue = this.elements[tableIndex].table.rowIndicators[rowIndex] || "";
            this.blueModalForm = { selectedOption: "indicadorPGDI", productionIndicator: currentValue };
            this.$bvModal.show('blueOptModal');
        },

        saveBlueModal(updatedBlue) {
            const tableData = this.elements[this.currentTableIndex].table;
            const duplicate = tableData.rowIndicators.some(
                (item, idx) => idx !== this.currentRowIndex && item === updatedBlue.productionIndicator
            );
            if (duplicate) {
                this.openToast(this.$t("variable-already"), "Atenção", "warning");
                return;
            }
            this.$set(tableData.rowIndicators, this.currentRowIndex, updatedBlue.productionIndicator);
            tableData.cells[this.currentRowIndex][0].value = updatedBlue.productionIndicator;
            this.updateIntersectionsForRow(this.currentTableIndex, this.currentRowIndex);
            this.closeBlueModal();
        },

        closeBlueModal() {
            this.$bvModal.hide('blueOptModal');
            this.currentTableIndex = null;
            this.currentRowIndex = null;
        },

        openOrangeModal(tableIndex, colIndex) {
            this.currentTableIndex = tableIndex;
            this.currentColIndex = colIndex;
            this.showOrangeModal = true;
            this.$bvModal.show("orangeOptModal");
        },

        selectOrangeOption(option) {
            const tableData = this.elements[this.currentTableIndex].table;
            const duplicate = tableData.columnHeaders.some(
                (item, idx) => idx !== this.currentColIndex && item === option
            );
            if (duplicate) {
                this.openToast(this.$t("column-already"), "Atenção", "warning");
                return;
            }
            this.$set(tableData.columnHeaders, this.currentColIndex, option);
            tableData.cells[0][this.currentColIndex].value = option;
            this.updateIntersectionsForColumn(this.currentTableIndex, this.currentColIndex);
            this.closeOrangeModal();
        },

        closeOrangeModal() {
            this.$bvModal.hide("orangeOptModal");
            this.currentTableIndex = null;
            this.currentColIndex = null;
        },

        updateTableDataType(tableIndex) {
            const tableData = this.elements[tableIndex].table;
            for (let r = 1; r < tableData.rows; r++) {
                this.updateIntersectionsForRow(tableIndex, r);
            }
        },

        updateIntersectionsForRow(tableIndex, rowIndex) {
            const tableData = this.elements[tableIndex].table;
            for (let c = 1; c < tableData.cols; c++) {
                this.updateIntersection(tableIndex, rowIndex, c);
            }
        },

        updateIntersectionsForColumn(tableIndex, colIndex) {
            const tableData = this.elements[tableIndex].table;
            for (let r = 1; r < tableData.rows; r++) {
                this.updateIntersection(tableIndex, r, colIndex);
            }
        },

        updateIntersection(tableIndex, r, c) {
            const tableData = this.elements[tableIndex].table;
            if (this.isFutureDate) {
                tableData.cells[r][c].value = "-";
                return;
            }

            const indicator = tableData.rowIndicators[r];
            const header = tableData.columnHeaders[c];
            let result = "";

            if (indicator && header) {
                const metaKey = `${indicator}_${header}`;

                if (this.isMetaTurno(header) && tableData.metaSettings && tableData.metaSettings[metaKey]) {
                    result = tableData.metaSettings[metaKey].value || "-";
                }
                else if (header === "Meta PGDI" && tableData.metaSettings && tableData.metaSettings[metaKey]) {
                    result = tableData.metaSettings[metaKey].value || "-";
                }
                else if (header === "Meta Plano") {
                    const equation = tableData.metaPlanoEquations && tableData.metaPlanoEquations[indicator];
                    result = equation ? this.evaluateMetaPlanoEquation(equation) : "-";
                }
                else if (indicator === "Gatilhos disparados" || indicator === "Gatilhos tratados") {
                    let type = tableData.dataType || "media";
                    if (this.triggersData[indicator] &&
                        this.triggersData[indicator][type] &&
                        this.triggersData[indicator][type][header] !== undefined) {
                        result = this.triggersData[indicator][type][header];
                    } else {
                        result = "-";
                    }
                }
                else {
                    let dataType = tableData.dataType || "media";
                    if (this.indicatorData[indicator] &&
                        this.indicatorData[indicator][dataType] &&
                        this.indicatorData[indicator][dataType][header] !== undefined) {
                        result = this.indicatorData[indicator][dataType][header];
                    } else {
                        result = "-";
                    }
                }
            }
            tableData.cells[r][c].value = result;
        },

        getCellStyle(element, colIndex) {
            if (!this.isTodayDate) { return {}; }

            if (element.table && element.table.columnHeaders && element.table.columnHeaders[colIndex]) {
                const validColumns = ["total", "ritmo", "media", "maior valor", "menor valor"];
                const normalize = str => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                const header = normalize(element.table.columnHeaders[colIndex]);
                if (validColumns.includes(header)) {
                    return { color: "#009a9a" };
                }
                if (["turno a", "turno b", "turno c"].includes(header) && this.workshiftData && this.workshiftData.length >= 3) {
                    let turnoIndex;
                    if (header === "turno a") {
                        turnoIndex = 0;
                    } else if (header === "turno b") {
                        turnoIndex = 1;
                    } else if (header === "turno c") {
                        turnoIndex = 2;
                    }
                    const turno = this.workshiftData[turnoIndex];
                    if (turno) {
                        const [startH, startM, startS] = turno.start.split(":").map(Number);
                        const [endH, endM, endS] = turno.end.split(":").map(Number);
                        const startSeconds = startH * 3600 + startM * 60 + startS;
                        const endSeconds = endH * 3600 + endM * 60 + endS;
                        const now = new Date();
                        const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
                        let active = false;
                        if (startSeconds <= endSeconds) {
                            active = currentSeconds >= startSeconds && currentSeconds <= endSeconds;
                        } else {
                            active = currentSeconds >= startSeconds || currentSeconds <= endSeconds;
                        }
                        if (active) {
                            return { color: "#009a9a" };
                        }
                    }
                }
            }
            return {};
        },


        openMetaModalForTable(tableIndex, colIndex) {
            const tableData = this.elements[tableIndex].table;
            const header = tableData.columnHeaders[colIndex];

            if (this.isMetaTurno(header)) {
                this.openTurnoMetaModal(tableIndex, colIndex, header);
            } else {
                this.openRegularMetaModal(tableIndex, colIndex);
            }
        },

        openTurnoMetaModal(tableIndex, colIndex, header) {
            const tableData = this.elements[tableIndex].table;
            this.currentMetaTableIndex = tableIndex;
            this.currentMetaColIndex = colIndex;

            const turno = this.workshiftData.find(t =>
                header === `Meta ${t.description}`
            );
            this.currentTurnoMeta = turno ? turno.description : header.replace("Meta ", "");

            this.turnoMetaItems = [];
            for (let r = 1; r < tableData.rows; r++) {
                const variable = tableData.rowIndicators[r];
                if (variable) {
                    const metaKey = `${variable}_${header}`;
                    const metaValue = tableData.metaSettings && tableData.metaSettings[metaKey]
                        ? (typeof tableData.metaSettings[metaKey] === "object"
                            ? tableData.metaSettings[metaKey].value
                            : tableData.metaSettings[metaKey])
                        : "";

                    this.turnoMetaItems.push({
                        variable,
                        metaValue
                    });
                }
            }

            this.$bvModal.show("turnoMetaModal");
        },

        openRegularMetaModal(tableIndex, colIndex) {
            this.currentMetaTableIndex = tableIndex;
            this.currentMetaColIndex = colIndex;
            const tableData = this.elements[tableIndex].table;
            this.metaSettings = [];
            const used = {};

            for (let r = 1; r < tableData.rows; r++) {
                const variable = tableData.rowIndicators[r];
                if (variable && !used[variable]) {
                    let defaultMetaSource = "pgdi";
                    let defaultManualValue = "";
                    const metaKey = `${variable}_${tableData.columnHeaders[colIndex]}`;
                    if (tableData.metaSettings && tableData.metaSettings[metaKey] && typeof tableData.metaSettings[metaKey] === "object") {
                        defaultMetaSource = tableData.metaSettings[metaKey].metaSource;
                        defaultManualValue = tableData.metaSettings[metaKey].value;
                    }
                    this.metaSettings.push({
                        variable,
                        metaSource: defaultMetaSource,
                        manualValue: defaultManualValue
                    });
                    used[variable] = true;
                }
            }
            this.$bvModal.show("goalModal");
        },

        saveTurnoMeta(metaItems) {
            const tableData = this.elements[this.currentMetaTableIndex].table;
            if (!tableData.metaSettings) {
                tableData.metaSettings = {};
            }

            const header = tableData.columnHeaders[this.currentMetaColIndex];

            metaItems.forEach(item => {
                const metaKey = `${item.variable}_${header}`;
                if (item.metaValue && item.metaValue.trim() !== "") {
                    tableData.metaSettings[metaKey] = {
                        metaSource: "manual",
                        value: item.metaValue
                    };
                } else {
                    delete tableData.metaSettings[metaKey];
                }
            });

            for (let r = 1; r < tableData.rows; r++) {
                const variable = tableData.rowIndicators[r];
                if (variable) {
                    this.updateIntersection(this.currentMetaTableIndex, r, this.currentMetaColIndex);
                }
            }

            this.closeTurnoMetaModal();
        },

        closeTurnoMetaModal() {
            this.$bvModal.hide("turnoMetaModal");
            this.currentMetaTableIndex = null;
            this.currentMetaColIndex = null;
            this.currentTurnoMeta = "";
            this.turnoMetaItems = [];
        },

        saveMetaModalForTable(updatedMetaSettings) {
            const tableData = this.elements[this.currentMetaTableIndex].table;
            if (!tableData.metaSettings) {
                tableData.metaSettings = {};
            }
            const colHeader = tableData.columnHeaders[this.currentMetaColIndex];
            updatedMetaSettings.forEach(item => {
                const metaKey = `${item.variable}_${colHeader}`;
                tableData.metaSettings[metaKey] = {
                    metaSource: item.metaSource,
                    value: item.metaSource === "pgdi"
                        ? (this.indicatorData[item.variable] &&
                            this.indicatorData[item.variable][tableData.dataType] &&
                            this.indicatorData[item.variable][tableData.dataType][colHeader] !== undefined
                            ? this.indicatorData[item.variable][tableData.dataType][colHeader]
                            : "")
                        : item.manualValue
                };
            });
            for (let r = 1; r < tableData.rows; r++) {
                if (tableData.rowIndicators[r]) {
                    this.updateIntersection(this.currentMetaTableIndex, r, this.currentMetaColIndex);
                }
            }
            this.closeMetaModalForTable();
        },

        closeMetaModalForTable() {
            this.$bvModal.hide("goalModal");
            this.currentMetaTableIndex = null;
            this.currentMetaColIndex = null;
            this.metaSettings = [];
        },

        finalizeTable(tableIndex) {
            const tableData = this.elements[tableIndex].table;
            for (let r = tableData.rows - 1; r > 0; r--) {
                const rowIsEmpty = tableData.cells[r]
                    .slice(1)
                    .every(cell => !cell.value || (this.isFutureDate && cell.value === "-"));
                if (!tableData.rowIndicators[r] && rowIsEmpty) {
                    tableData.cells.splice(r, 1);
                    tableData.rowIndicators.splice(r, 1);
                    tableData.rows--;
                }
            }
            for (let c = tableData.cols - 1; c > 0; c--) {
                if (!tableData.columnHeaders[c] && tableData.cells[0][c].value === "") {
                    let empty = true;
                    for (let r = 1; r < tableData.rows; r++) {
                        const cellVal = tableData.cells[r][c].value;
                        if (cellVal && !(this.isFutureDate && cellVal === "-")) {
                            empty = false;
                            break;
                        }
                    }
                    if (empty) {
                        tableData.cells.forEach(row => row.splice(c, 1));
                        tableData.columnHeaders.splice(c, 1);
                        tableData.cols--;
                    }
                }
            }
            tableData.finalized = true;
        },

        editTable(tableIndex) {
            const tableData = this.elements[tableIndex].table;
            tableData.finalized = false;
        },

        fetchIndicators() {
            axios.get(`${urlMainAPI}/getindicatorlist`)
                .then(response => {
                    try {
                        const uniqueIndicators = response.data.filter((indicator, index, self) =>
                            index === self.findIndex(i => i.indicatorId === indicator.indicatorId)
                        );
                        this.indicators = uniqueIndicators;
                    } catch (e) {
                        this.indicators = response.data;
                    }
                })
                .catch(error => {
                    this.openToast(this.$t("ind-search-error") + ` ${error}`, "Erro", "danger");
                });
        },

        fetchScreensAndAreas() {
            axios.get(`${urlMainAPI}/getscreensandareas`)
                .then(response => {
                    try {
                        this.screensAreas = response.data;
                    } catch (e) {
                        this.screensAreas = response.data;
                    }
                })
                .catch(error => {
                    this.openToast(this.$t("ind-search-error") + ` ${error}`, "Erro", "danger");
                });
        },

        async fetchShiftReportTurnoData() {
            const unitId = this.user && parseInt(this.user.UnitId);
            if (!unitId || !this.selectedDate) return;

            const date = this.formatDate(this.selectedDate);
            try {
                const [{ data: rawShiftData }, areasRes, indicatorsRes] = await Promise.all([
                    axios.get(`${urlMainAPI}/shiftreport/${unitId}/${date}`),
                    axios.get(`${urlMainAPI}/shiftreport/rootareas?unitId=${unitId}`),
                    axios.get(`${urlMainAPI}/shiftreport/indicators?unitId=${unitId}`),
                ]);
                const data = typeof rawShiftData === 'string' ? JSON.parse(rawShiftData) : (rawShiftData || {});

                // Monta mapa de resolução de IDs → nomes
                const domainMap = {};
                (data.allDomains || []).forEach(d => { domainMap[d.id] = d.value; });
                const rawAreas = typeof areasRes.data === 'string' ? JSON.parse(areasRes.data) : (areasRes.data || []);
                rawAreas.forEach(a => { domainMap[-(a.id)] = a.indicatorName; });
                const rawIndicators = typeof indicatorsRes.data === 'string' ? JSON.parse(indicatorsRes.data) : (indicatorsRes.data || []);
                rawIndicators.forEach(i => { domainMap[-(i.id)] = i.indicatorName; });
                // Presets estáticos (mesmos do ShiftReportUnified)
                Object.assign(domainMap, {
                    [-10001]: 'Agrícola', [-10002]: 'Processo', [-10003]: 'Manutenção',
                    [-10004]: 'Qualidade', [-10005]: 'Segurança',
                    [-20001]: 'Alta', [-20002]: 'Média', [-20003]: 'Baixa',
                    [-30001]: 'Em andamento', [-30002]: 'Pendente', [-30003]: 'Concluído',
                    [-40001]: 'm/min', [-40002]: 'RPM',
                    [-50001]: 'Mecânica', [-50002]: 'Instrumentação', [-50003]: 'Elétrica',
                    [-50004]: 'Caldeiraria', [-50005]: 'Preditiva', [-50006]: 'Manutenção Autônoma',
                });
                const resolve = (id) => domainMap[id] || '—';

                // Aba Relatos → shiftReportRelatos
                this.shiftReportRelatos = (data.relatos || []).filter(r => r.id !== 0).map(r => ({
                    Turno: r.turnoId,
                    Area: resolve(r.areaDomainId),
                    TipoOcorrido: resolve(r.tipoDomainId),
                    Descricao: r.description || '',
                    UserName: r.userName || '',
                }));

                // Aba Produção → shiftReportProducao
                this.shiftReportProducao = (data.producao || []).filter(r => r.id !== 0).map(r => ({
                    Type: resolve(r.tipoDomainId),
                    Name: resolve(r.indicadorDomainId),
                    TurnoA: r.turnoA,
                    TurnoB: r.turnoB,
                    TurnoC: r.turnoC,
                    Total: r.total,
                    Meta: r.meta,
                    Observacao: r.observacao,
                    UserName: r.userName || '',
                }));

                // Aba Manutenção → shiftReportManutencao
                this.shiftReportManutencao = (data.manutencao || []).filter(r => r.id !== 0).map(r => ({
                    Turno: r.turnoId,
                    Equipamento: r.equipamento || '—',
                    Prioridade: resolve(r.prioridadeDomainId),
                    Area: resolve(r.areaDomainId),
                    Descricao: r.description || '—',
                    Oficina: resolve(r.oficinaDomainId),
                    Status: resolve(r.statusDomainId),
                    OtOs: r.otOs || '—',
                    UserName: r.userName || '',
                }));

                // Aba Moagem → shiftReportMoagem
                this.shiftReportMoagem = (data.moagem || []).filter(r => r.id !== 0).map(r => ({
                    Turno: r.turnoId,
                    Inicio: r.inicio || '—',
                    Termino: r.termino || '—',
                    Duracao: r.duracao || '—',
                    Observacao: r.observacao || '—',
                    Um: r.umDomainId ? resolve(r.umDomainId) : '—',
                    Motivo: r.motivo || '—',
                    UserName: r.userName || '',
                }));

            } catch (err) {
                this.openToast('Erro ao carregar dados do relato de turno: ' + err, 'Erro', 'danger');
            }
        },

        async fetchMockPgdiData(dateOverride) {
            const dateToUse = dateOverride || this.formatDate(this.selectedDate);
            const url = `${urlMainAPI}/pgdidata/${dateToUse}/${this.reportTemplateName}`;
            try {
                const { data } = await axios.get(url);
                this.indicatorData = data.indicator;
                this.triggersData  = data.trigger;
                this.occurrences   = data.occurrences;
                this.closingWorkshift = data.closingWorkshift;
                this.pgdiMetrics   = data.metrics || {};
            } catch (err) {
                this.openToast(this.$t("ind-search-error") + ` ${err}`, "Erro", "danger");
            }
        },

        convertTurno(turnoValue) {
            const num = Number(turnoValue);
            if (!isNaN(num) && this.workshiftData && this.workshiftData.length > 0) {
                const turno = this.workshiftData.find(t => t.id === num);
                if (turno) {
                    return turno.description;
                }
            }
            return turnoValue;
        },


        updateOccurrenceTables() {
            if (!this.occurrences || !this.occurrences.Reports) return;
            this.elements.forEach((element) => {
                if (element.type === "tableOccurrence" && element.tableOccurrence) {
                    let config = element.tableOccurrence;
                    if (!config.SelectedTurno || config.SelectedTurno === "") {
                        element.tableOccurrence.rows = [];
                        return;
                    }

                    let newRows = [];
                    const selectedTurno = config.SelectedTurno || "";
                    const selectedCategory = config.SelectedCategory || "todosIndicadores";
                    const selectedTela = config.SelectedTela || "";
                    const selectedArea = config.SelectedArea || "";
                    for (let report of this.occurrences.Reports) {
                        if (!report.Details || !Array.isArray(report.Details)) continue;
                        for (let detail of report.Details) {
                            if (!detail.Turno) continue;
                            if (selectedTurno && selectedTurno.toUpperCase() !== "TODOS" && detail.Turno.toUpperCase() !== selectedTurno.toUpperCase()) continue;

                            if (selectedCategory === "indicadoresTela") {
                                if (!report.Screens || !Array.isArray(report.Screens) || !report.Screens.includes(selectedTela)) continue;
                            } else if (selectedCategory === "indicadoresArea") {
                                if (!report.Screens || !Array.isArray(report.Screens) || !report.Screens.includes(selectedTela)) continue;
                                if (!report.Areas || !Array.isArray(report.Areas) || !report.Areas.includes(selectedArea)) continue;
                            }

                            let metaValue = "";
                            if (detail.Meta && detail.Meta.indexOf("%") !== -1) {
                                metaValue = "-";
                            } else {
                                metaValue = detail.Meta;
                            }

                            let motivo = "";
                            let acao = "";
                            if (detail.Reasons && Array.isArray(detail.Reasons) && detail.Reasons.length > 0) {
                                motivo = detail.Reasons[0].Motivo || "";
                                acao = detail.Reasons[0].Acao || "";
                            }
                            newRows.push([
                                report.IndicatorName || "-",
                                detail.Turno || "-",
                                detail.Aderencia || "-",
                                detail.MetaAderencia || "-",
                                detail.Realizado || "-",
                                metaValue || "-",
                                detail.ValorMedio || "-",
                                detail.LowerLimit || "-",
                                detail.UpperLimit || "-",
                                motivo || "-",
                                acao || "-"
                            ]);

                            if (detail.Reasons && detail.Reasons.length > 1) {
                                for (let i = 1; i < detail.Reasons.length; i++) {
                                    newRows.push([
                                        "", "", "", "", "", "", "", "", "",
                                        detail.Reasons[i].Motivo || "",
                                        detail.Reasons[i].Acao || ""
                                    ]);
                                }
                            }
                        }
                    }
                    element.tableOccurrence.rows = newRows;
                }
            });
            this.$nextTick(() => this.adjustPositions());
        },

        async viewReportModel(model) {
            this.$bvModal.hide("reportModelsModal");
            await this.getReportByName(model.Name);
            this.updateOccurrenceTables();
            await this.renderReport();
            this.editMode = false;
            this.reportFound = true;
            this.openToast("Visualizando modelo do relatório", "Visualização", "success");
        },

        async renderReport() {
            this.elements.forEach((element) => {
                if (element.type === "chart") {
                    if (element.chartGauge) {
                        element.chartType = element.chartGauge.chartType;
                        element.indicator = { indicatorName: element.chartGauge.indicator };
                        element.metaConfig = {
                            indicator: element.indicator,
                            metaValue: element.chartGauge.goal
                        };

                        const foundInd = this.indicators.find(
                            x => x.indicatorName === element.chartGauge.indicator
                        );

                        if (foundInd) {
                            element.indicator = foundInd;
                            element.metaConfig.indicator = foundInd;
                            const computedOption = this.computeChartOption(
                                foundInd,
                                element.chartType,
                                "Real",
                                element.chartGauge.goal
                            );
                            this.$set(element, "option", computedOption);
                        } else {
                            this.$set(element, "option", this.createDefaultChartOption(element.chartType));
                        }
                    } else if (element.chartBarras) {
                        element.chartType = element.chartBarras.chartType;
                        element.indicator = null;
                        element.metaConfig = { indicator: null, metaValue: "" };
                        this.$set(element, "option", this.computeChartBarOption(element.chartBarras));
                    } else {
                        element.chartType = "pizza";
                        element.indicator = null;
                        element.metaConfig = { indicator: null, metaValue: "" };
                        this.$set(element, "option", this.createDefaultChartOption("pizza"));
                    }

                    element.dynamic = true;
                }
            });
            await this.$nextTick();

            this.adjustPositions();
        },

        closeWhatsAppModal() {
            this.showWhatsAppModal = false;
        },

        async loadDailySendCount() {
            try {
                const raw = await axios.get(`${urlMainAPI}/getdailysendcount`);
                const data = typeof raw.data === 'string' ? JSON.parse(raw.data) : raw.data;
                const sent = typeof data?.sent === 'number' ? data.sent : 0;
                const limit = typeof data?.limit === 'number' ? data.limit : 4;
                this.sendCount = sent;
                this.sendLimit = limit;
            } catch {
                // silencioso — não bloqueia o carregamento
            }
        },

        async loadSendMode() {
            try {
                const raw = await axios.get(`${urlMainAPI}/getreportsendconfig`);
                const data = typeof raw.data === 'string' ? JSON.parse(raw.data) : raw.data;
                this.sendMode = (typeof data?.sendMode === 'string') ? data.sendMode : 'manual';
                this.sendLimit = (typeof data?.maxDailyWhatsAppSends === 'number') ? data.maxDailyWhatsAppSends : 4;
            } catch {
                // silencioso
            }
        },

        async sendManual() {
            if (this.sendCount >= this.sendLimit) {
                this.openToast('Limite diário de envios atingido.', 'Aviso', 'warning');
                return;
            }
            try {
                await this.exportPDFRobot();
                await this.loadDailySendCount();
            } catch (err) {
                this.openToast('Erro ao enviar relatório: ' + err.message, 'Erro', 'danger');
            }
        },

        exitEditMode() {
            this.editMode = false;
            this.loadDailySendCount();
        },

        openSendConfig() {
            this.$bvModal.show('SendConfigModal');
        },

        onSendConfigSaved({ sendMode }) {
            this.sendMode = sendMode;
            this.openToast('Configuração de envio salva.', 'Sucesso', 'success');
        },

        relatoTabLabel(tab) {
            const labels = {
                relatos: 'Relatos',
                producao: 'Produção',
                manutencao: 'Manutenção',
                moagem: 'Moagem'
            };
            return labels[tab] || tab;
        },

        openAddRelatoTurno() {
            this.currentRelatoIndex = null;
            this.currentRelatoEditData = null;
            this.$bvModal.show('RelatoTurnoModal');
        },

        onRelatoConfirm({ tabs, title, color }) {
            if (this.currentRelatoIndex !== null) {
                const element = this.elements[this.currentRelatoIndex];
                if (element) {
                    element.title.text = title || element.title.text;
                    element.title.color = color || element.title.color;
                    element.tabs = tabs;
                    element.activeTab = tabs[0];
                }
                this.currentRelatoIndex = null;
                this.currentRelatoEditData = null;
            } else {
                this.addRelatoTurnoWidget(tabs);
            }
        },

        addRelatoTurnoWidget(selectedTabs) {
            const pos = { left: 40, top: this.getLastElementBottom() };
            const title = selectedTabs.length === 1
                ? this.relatoTabLabel(selectedTabs[0]).toUpperCase()
                : 'RELATO DE TURNO';
            const newWidget = {
                id: (Date.now() + Math.random()).toString(),
                type: 'relatoTurno',
                title: { text: title, color: '#333' },
                tabs: selectedTabs,
                activeTab: selectedTabs[0],
                position: pos,
                width: null,
                height: null,
                order: this.elements.length
            };
            this.elements.push(newWidget);
            this.measureNew(newWidget);
        },

        async openWhatsapp() {
            try {
                await this.loadAvailableUsers();
                this.showWhatsAppModal = true;
            } catch (error) {
                console.error('Erro ao carregar usuários:', error);
                this.openToast(this.$t('erro-carregar-usuarios'), 'Erro', 'error');
            }
        },

        async loadAvailableUsers() {
            try {
                const response = await axios.get(`${urlMainAPI}/getusers`);
                this.availableUsers = response.data.sort((a, b) => {
                    return a.name.localeCompare(b.name, 'pt-BR');
                });

                try {
                    const whatsappResponse = await axios.get(`${urlMainAPI}/getwhatsappusers`);
                    console.log('WhatsApp users:', whatsappResponse.data);

                    this.whatsappUsersData = whatsappResponse.data;

                    const activeUsers = whatsappResponse.data
                        .filter(user => user.isActive)
                        .map(user => ({
                            userId: user.userId,
                            whatsAppNumber: user.whatsAppNumber
                        }));

                    this.preSelectedWhatsAppUsers = activeUsers;
                } catch (whatsappError) {
                    console.error('Erro ao carregar usuários do WhatsApp:', whatsappError);
                }
            } catch (error) {
                console.error('Erro ao carregar usuários:', error);
                this.openToast(this.$t('erro-carregar-usuarios'), 'Erro', 'error');
                throw error;
            }
        },
        
        async handleSaveWhatsAppUsers(users) {
            try {
                console.time('saveWhatsAppUsers');
                console.log('Enviando dados:', users);

                const response = await axios.post(`${urlMainAPI}/savewhatsappusers`, users);
                console.timeEnd('saveWhatsAppUsers');
                console.log('Resposta da API:', response.data);

                this.openToast(this.$t('usuarios-whatsapp-salvos'), 'Sucesso', 'success');
                this.closeWhatsAppModal();
            } catch (error) {
                console.timeEnd('saveWhatsAppUsers');
                console.error('Erro ao salvar usuários do WhatsApp:', error);
                console.error('Detalhes do erro:', {
                    message: error.message,
                    response: error.response?.data,
                    status: error.response?.status
                });
                this.openToast(this.$t('erro-salvar-usuarios-whatsapp'), 'Erro', 'error');
            }
        },

        getHeaderStyle(header) {
            if (!this.isTodayDate) {
                return {};
            }

            if (this.isTurno(header)) {
                const turno = this.workshiftData.find(t =>
                    t.description.toLowerCase() === header.toLowerCase()
                );
                if (turno) {
                    const [startH, startM, startS] = turno.start.split(":").map(Number);
                    const [endH, endM, endS] = turno.end.split(":").map(Number);
                    const startSeconds = startH * 3600 + startM * 60 + startS;
                    const endSeconds = endH * 3600 + endM * 60 + endS;
                    const now = new Date();
                    const currentSeconds = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
                    let active = false;
                    if (startSeconds <= endSeconds) {
                        active = currentSeconds >= startSeconds && currentSeconds <= endSeconds;
                    } else {
                        active = currentSeconds >= startSeconds || currentSeconds <= endSeconds;
                    }
                    if (active) {
                        return { color: "#009a9a" };
                    }
                }
            }
            return {};
        },

        updateOrangeOptions() {
            const baseOptions = ["Total", "Meta PGDI", "Meta Plano", "Ritmo", "Média", "Maior valor", "Menor valor"];
            const turnoOptions = [];
            const metaTurnoOptions = [];

            if (this.workshiftData && this.workshiftData.length > 0) {
                this.workshiftData.forEach(turno => {
                    if (turno.id >= 1 && turno.id <= 3) {
                        turnoOptions.push(turno.description);
                        metaTurnoOptions.push(`Meta ${turno.description}`);
                    }
                });
            } else {
                turnoOptions.push("Turno A", "Turno B", "Turno C");
                metaTurnoOptions.push("Meta Turno A", "Meta Turno B", "Meta Turno C");
            }

            this.orangeOptions = [...turnoOptions, ...metaTurnoOptions, ...baseOptions];
        },

        openMetaPlanoModal(tableIndex, rowIndex, colIndex) {
            const tableData = this.elements[tableIndex].table;
            this.currentMetaPlanoTableIndex = tableIndex;
            this.currentMetaPlanoRowIndex = rowIndex;
            this.currentMetaPlanoColIndex = colIndex;
            this.currentMetaPlanoIndicator = tableData.rowIndicators[rowIndex] || '';
            const indicator = this.currentMetaPlanoIndicator;
            this.currentMetaPlanoEquation = (tableData.metaPlanoEquations && tableData.metaPlanoEquations[indicator]) || '';
            this.currentMetaPlanoComment = (tableData.metaPlanoComments && tableData.metaPlanoComments[indicator]) || '';
            this.showMetaPlanoModal = true;
        },

        saveMetaPlanoEquation(equation, comment, evaluatedValue) {
            const tIdx = this.currentMetaPlanoTableIndex;
            const rIdx = this.currentMetaPlanoRowIndex;
            const cIdx = this.currentMetaPlanoColIndex;
            const tableData = this.elements[tIdx].table;
            const indicator = this.currentMetaPlanoIndicator;

            if (!tableData.metaPlanoEquations) this.$set(tableData, 'metaPlanoEquations', {});
            if (!tableData.metaPlanoComments) this.$set(tableData, 'metaPlanoComments', {});
            if (!tableData.metaPlanoValues) this.$set(tableData, 'metaPlanoValues', {});

            if (equation && equation.trim()) {
                this.$set(tableData.metaPlanoEquations, indicator, equation.trim());
                this.$set(tableData.metaPlanoComments, indicator, (comment || '').trim());
                const display = (evaluatedValue !== undefined && evaluatedValue !== '-')
                    ? String(evaluatedValue)
                    : '-';
                this.$set(tableData.metaPlanoValues, indicator, display);
                if (tableData.cells[rIdx] && tableData.cells[rIdx][cIdx]) {
                    tableData.cells[rIdx][cIdx].value = display;
                }
            } else {
                this.$delete(tableData.metaPlanoEquations, indicator);
                this.$delete(tableData.metaPlanoComments, indicator);
                this.$delete(tableData.metaPlanoValues, indicator);
                this.updateIntersection(tIdx, rIdx, cIdx);
            }
            this.showMetaPlanoModal = false;
        },

        getMetaPlanoEquation(element, rIndex) {
            if (!element.table.metaPlanoEquations) return '';
            const indicator = element.table.rowIndicators[rIndex];
            return element.table.metaPlanoEquations[indicator] || '';
        },

        evaluateMetaPlanoEquation(equation) {
            const result = MediatorIndicatorEditor.evaluatePlanEquation(equation, MediatorIndicatorEditor.harvestPlanList);
            return result === '-' ? '-' : String(result);
        },

        isMetaTurno(header) {
            if (!header || !this.workshiftData) return false;
            return this.workshiftData.some(turno =>
                header.toLowerCase().startsWith('meta ') &&
                header.toLowerCase().endsWith(turno.description.toLowerCase())
            );
        },

        isTurno(header) {
            if (!header || !this.workshiftData) return false;
            return this.workshiftData.some(turno =>
                header.toLowerCase() === turno.description.toLowerCase()
            );
        },

        getColumnStyle(element, cIndex) {
            if (element.table && element.table.columnHeaders) {
                const header = element.table.columnHeaders[cIndex];
                if (this.isMetaTurno(header) && element.table.cells && element.table.cells[0] && element.table.cells[0][cIndex]) {
                    return { color: "#FF5F00" };
                }
            }
            return {};
        },

        log(o) {
    console.log('🐛 debug:', o);
    return ''; // pra não renderar nada
  },
    },

    computed: {
        ...mapState(["user"]),
        isFutureDate() {
            const selected = new Date(this.formatDate(this.selectedDate));
            const today = new Date(this.formatDate(new Date()));
            return selected > today;
        },

        isTodayDate() {
            const sel = this.formatDate(this.selectedDate);
            const today = this.formatDate(new Date());
            return sel === today;
        },

        sortedElements() {
            return [...this.elements].sort((a, b) => a.order - b.order);
        },

        loadingMessage() {
            return this.loadingMessages[this.loadingMessageIndex];
        }
    },

    watch: {
        pgdiMetrics() {
            this.elements.forEach(element => {
                if (element.type !== 'chart') return;

                if (element.chartType === 'velocimetro') {
                    const metaVal = element.metaConfig?.metaValue ?? '';
                    element.option = this.computeChartOption(
                        element.indicator,
                        element.chartType,
                        'Real',
                        metaVal
                    );
                } else if (element.chartType === "barras" || element.chartType === "barrasDeitadas") {
                    if (element.chartBarrasConfig) {
                        element.option = this.computeChartBarOption(element.chartBarrasConfig);
                    }
                }
            });
        },
        'elements': {
    deep: true,
    handler(arr) {
      const el = this.currentChartIndex != null ? arr[this.currentChartIndex] : null;
      if (el) console.log('🌼 watch element:', el);
    }
  }
    },

    async mounted() {
        this.loadingMessageIndex = 0;
        this.startLoadingSequence();

        await this.syncSelectedDateWithBusinessDay(); 
        
        if (!this.selectedDate) {
            this.openToast("Não foi possível determinar a data de inicio dos turnos.", "Erro", "danger");
            this.loading = false;
            return;
        }

        await this.fetchWorkShift();
        this.fetchIndicators();
        this.fetchScreensAndAreas();

        await this.searchReport("pesquisa");

        this.loadDailySendCount();
        this.loadSendMode();
    },
};
</script>

<style scoped>
.custom-loader-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 70vh;
    background-color: white;
    color: black;
    margin-top: 10vh;
}

.spinner {
    border: 6px solid #e0e0e0;
    border-top: 6px solid #007bff;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

.loading-msg {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    max-width: 300px;
    color: black;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.relatorios-container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.top-bar {
    height: 55px;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    gap: 3px;
    z-index: 100;
    position: sticky;
    top: 0;
    flex-shrink: 0;
}

.report-grid-container {
    position: relative;
    height: calc(100vh - 90px);
    min-width: 100%;
    width: fit-content;
    padding: 20px;
    margin: 0 0 20px 0;
    overflow-y: scroll;
    scrollbar-width: none;
    overflow-x: auto;
    min-height: 2000px;
    -ms-overflow-style: none;
}

.report-grid-container::-webkit-scrollbar {
    display: none;
}

.show-grid {
    background-image: linear-gradient(#ddd 1px, transparent 1px), linear-gradient(90deg, #ddd 1px, transparent 1px);
    background-size: 35px 35px;
    background-position: 0 0;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    min-height: 2000px;
}

.relatorios-container {
    height: 83vh;
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.date-input {
    margin-right: 10px;
}

.img-btn {
    width: 30px;
    height: 30px;
}

.img-btn-big {
    width: 33px;
    height: 33px;
}

.action-btn {
    margin-left: 2px;
    margin-right: 5px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #ff751b;
    font-size: 20px;
}

.action-btn i {
    vertical-align: middle;
}

.no-config {
    font-size: 18px;
    text-align: center;
}

.iconPermission {
    position: absolute;
    width: 400px;
    top: calc(45% - 158px);
    left: calc(45% - 158px);
    opacity: 0.1;
}

.clockText {
    position: absolute;
    top: 50%;
    text-align: center;
    width: 93%;
    font-size: 1.5rem;
    margin-left: 1.4rem;
}

.header-box {
    width: 100%;
    height: 40px;
    margin: 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    position: relative;
    padding: 0 10px;
}

.gear-icon {
    position: absolute;
    left: 10px;
    top: 13px;
    cursor: pointer;
}

.table-wrapper {
    margin: 10px 0;
    overflow-x: auto;
}

.config-table {
    border-collapse: collapse;
    width: 100%;
    min-width: 500px;
}

.config-table-cell {
    border: 1px solid #888686;
    width: 120px;
    height: 50px;
    text-align: center;
    vertical-align: middle;
    position: relative;
}

.icon-btn {
    border: none;
    cursor: pointer;
    color: #fff;
    border-radius: 4px;
    padding: none !important;
}

.icon-btn.orange {
    background-color: #ff751b;
}

.icon-btn.blue {
    background-color: #009a9a;
}

.table-header-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 5px;
}

.table-action-group {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.table-action-group.finalized {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.small-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 18px;
}

.add-row-btn {
    color: #009a9a;
}

.add-col-btn {
    color: #ff751b;
}

.finalize-btn,
.edit-btn {
    color: #ff751b;
}

.meta-info-icon {
    color: #ff751b;
    margin-left: 5px;
    cursor: pointer;
}

.meta-plano-calc-icon {
    color: #009a9a;
    margin-left: 5px;
    cursor: pointer;
    font-size: 14px;
}

.meta-plano-missing {
    color: #e65c00;
    font-size: 11px;
    font-style: italic;
    white-space: nowrap;
}

.meta-plano-calc-icon:hover {
    color: #007070;
}

.meta-plano-eq-preview {
    font-size: 11px;
    color: #666;
    margin-right: 3px;
}


.text-element {
    margin: 10px 0;
    font-size: 16px;
}

.text-border {
    border: 1px solid #000;
    padding: 5px;
}

.chart-element {
    margin: 20px 0;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.modal-content {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    width: 400px;
}

.modal-content h3 {
    margin-top: 0;
}

.modal-buttons {
    margin-top: 20px;
    text-align: right;
}

.modal-buttons button {
    margin-left: 10px;
}

.clickable-item {
    cursor: pointer;
    margin: 5px 0;
}

.color-radio-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 5px;
}

.radio-option {
    margin: 10px 0;
}

.select-indicador {
    display: block;
    margin-top: 5px;
}

.definir-metas-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
}

.definir-metas-table th,
.definir-metas-table td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
}

.definir-metas-table th {
    background: #f5f5f5;
}

.manual-input {
    margin-top: 5px;
    width: 80px;
}

.graph-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
}

.graph-grid-item {
    width: 150px;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    cursor: pointer;
    border-radius: 4px;
    background: #f9f9f9;
}

.graph-grid-item:hover {
    background: #eee;
}

.save-picker {
    margin-left: auto;
}

.txt-picker {
    margin-top: 3px;
    margin-left: -2px;
}

.toolbar {
    margin-bottom: 5px;
}

.toolbar button,
.toolbar select {
    margin-right: 5px;
    padding: 5px;
    font-size: 14px;
    cursor: pointer;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #3498db;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
}

.loading-over {
    width: 80px;
    height: 80px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.pen-edit {
    width: 10px;
    height: 10px;
}

.sum-select {
    margin-left: 5px;
}

.option-select {
    margin-top: 10px;
}

.option-select label {
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
}

.option-select input[type="radio"] {
    accent-color: #009a9a;
    cursor: pointer;
}

.button-confirm-00 {
    margin-bottom: 1px;
}

.img-btn-pen {
    margin-bottom: 4px;
}

button[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
}

@media (max-height: 750px) {
    :deep(.custom-modal) .modal-content {
        width: 60vh;
    }

    :deep(.custom-blue-modal) .modal-content {
        width: 65vh;
    }

    :deep(.custom-text-modal) .modal-content {
        width: 106%;
    }

    :deep(.custom-goal-modal) .modal-content {
        width: 108vh;
    }

    :deep(.modal-body) {
        padding: 0 !important;
    }
}

@media (min-height: 751px) {
    :deep(.custom-modal) .modal-content {
        width: 48vh;
    }

    :deep(.custom-blue-modal) .modal-content {
        width: 60vh;
    }

    :deep(.custom-text-modal) .modal-content {
        width: 110%;
    }

    :deep(.custom-goal-modal) .modal-content {
        width: 80vh;
    }

    :deep(.modal-body) {
        padding: 0 !important;
    }
}

.element-wrapper {
    position: relative;
    min-width: 300px;
    max-width: 95%;
    transition: box-shadow 0.2s ease;
}

.element-wrapper:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.element-wrapper:active {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.remove-btn {
    position: absolute;
    top: -20px;
    right: 5px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    z-index: 10;
}

.edit-btn-elements {
    margin-right: 20px;
}

.cell-with-edit {
    position: relative;
}

.cell-edit-padding {
    padding-right: 20px;
}

.config-table-icon {
    position: absolute;
    top: -4px;
    right: 6px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.centered-content {
    text-align: center;
    margin-left: 20px;
}

.bold-style {
    font-weight: bold;
}

.bold-style-colored {
    font-weight: bold;
    color: #009a9a;
}

.table-occurrence-wrapper {
    margin: 10px 0;
    overflow-x: auto;
    margin: 10px 0;
    overflow-x: auto;
}

.my-custom-table-class {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    border: 1px solid #ccc;
}

.my-custom-table-class thead th {
    background-color: #e2e2e2;
    text-align: center;
    padding: 8px;
    border: 1px solid #ccc;
    font-weight: bold;
    vertical-align: middle;
}

.my-custom-table-class tbody tr {
    border: 1px solid #ccc;
    height: 40px;
}

.my-custom-table-class tbody tr:nth-child(even) {
    background-color: #e2e2e2;
}

.my-custom-table-class tbody tr:nth-child(odd) {
    background-color: #ffffff;
}

.my-custom-table-class td {
    padding: 8px;
    border: 1px solid #ccc;
    text-align: center;
    vertical-align: middle;
}

.img-btn-txt {
    margin-top: 2px;
}

.img-btn-table-oc {
    margin-left: 8px !important;
    margin-top: 4px;
}

.img-btn-graph {
    margin-left: 11px;
    margin-top: 2px;
}

.img-btn-closing {
    width: 32px;
    margin-left: 12px;
    height: 32px;
    margin-top: 8px;
}

.chart-element {
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.chart-fallback {
    text-align: center;
}

.chart-edit-controls {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 5px;
}

/* Estilos do Modal de Gerenciamento de Modelos */
.modal-content-wrapper {
    padding: 0 20px;
}

.btn-container {
    margin-left: 2.5%;
    margin-bottom: 8px;
}

.btn-new-model {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background-color: #009a9a;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    transition: background-color 0.2s;
    margin-top: 8px;
}

.btn-new-model:hover {
    background-color: #007a7a;
}

.btn-icon {
    width: 14px;
    height: 14px;
    object-fit: contain;
}

.models-table-container {
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin: 0 auto;
    width: 95%;
    margin-bottom: 8px;
}

.models-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    table-layout: fixed;
}

.models-table th {
    background-color: #f5f5f5;
    padding: 12px;
    font-weight: 600;
    color: #333;
    border-bottom: 2px solid #ddd;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.models-table th:first-child {
    width: 45%;
    /* Nome do Modelo */
}

.default-header {
    text-align: center;
    width: 100px;
}

.models-table td {
    padding: 15px;
    border-bottom: 1px solid #eee;
}

.models-table tr:hover {
    background-color: #f9f9f9;
}

.default-model {
    background-color: #f0f9f9;
}

.default-model:hover {
    background-color: #e6f6f6;
}

.default-indicator {
    text-align: center;
    width: 100px;
}

.default-indicator-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.default-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.actions-cell {
    display: flex;
    gap: 8px;
    justify-content: center;
}

.btn-action {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.btn-action:hover {
    background-color: #f0f0f0;
}

.action-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
}

.action-icon-model {
    width: 16px;
    height: 16px;
}

.btn-close-modal {
    padding: 8px 16px;
    background-color: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
}

.btn-close-modal:hover {
    background-color: #e0e0e0;
}

/* Scrollbar personalizada para o container da tabela */
.models-table-container::-webkit-scrollbar {
    width: 8px;
}

.models-table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.models-table-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.models-table-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Estilos do Modal Novo Modelo */
.modal-body {
    padding: 20px;
}

.form-group {
    margin: 0 20px 20px 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
}

.form-control {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.form-control:focus {
    outline: none;
    border-color: #009a9a;
    box-shadow: 0 0 0 2px rgba(0, 154, 154, 0.1);
}

.custom-control {
    padding-left: 1.5rem;
}

.custom-control-input {
    width: 1rem;
    height: 1rem;
    margin-top: 0.25rem;
    margin-left: -1.5rem;
    vertical-align: top;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    border: 1px solid #ddd;
    appearance: none;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
}

.custom-control-input:checked {
    background-color: #009a9a;
    border-color: #009a9a;
}

.custom-control-label {
    position: relative;
    margin-bottom: 0;
    vertical-align: top;
    cursor: pointer;
    color: #333;
}

.modal-footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.btn {
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-secondary {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    color: #333;
}

.btn-secondary:hover {
    background-color: #e0e0e0;
}

.btn-primary {
    background-color: #009a9a;
    border: 1px solid #009a9a;
    color: white;
}

.btn-primary:hover {
    background-color: #007a7a;
}

.btn-primary:disabled {
    background-color: #cccccc;
    border-color: #cccccc;
    cursor: not-allowed;
}

.selected-model-label {
    margin-left: 10px;
    padding: 4px 8px;
    background-color: #f0f9f9;
    border-radius: 4px;
    color: #009a9a;
    font-size: 14px;
    font-weight: 500;
}

.loading-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    flex-direction: column;
}

.loading-over {
    width: 80px;
    height: 80px;
}

.class-modal-model {
    margin-bottom: 34px;
}

.input-edit-model {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 14px;
    width: 140px;
}

.btn-icon-sm {
    margin-left: 5px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

.btn-icon-sm-model {
    background: none;
    margin-top: 5px;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

.actions-header-modal {
    text-align: center;
    width: auto;
}

.save-model {
    margin-left: 5px;
}

.new-model-name {
    margin-top: 12px;
}

@media print {
    @page {
        size: auto;
        margin: 0;
    }
}

/* ---- TOOLBAR NOVOS BOTÕES ---- */
.toolbar-right-view {
    display: flex;
    align-items: center;
    gap: 6px;
}

.action-btn-sq {
    background: #fff;
    border: 1px solid #f37021;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    font-size: 16px;
    color: #f37021;
}

.limit-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
}

.limit-badge {
    font-size: 11px;
    background: #f8f8f8;
    border: 1px solid #ddd;
    padding: 5px 12px;
    border-radius: 20px;
    color: #666;
    font-weight: bold;
    white-space: nowrap;
}

.alert-exclamation {
    color: #e91e63;
    font-weight: bold;
    font-size: 18px;
    cursor: help;
    position: relative;
    display: inline-flex;
    align-items: center;
}

.commercial-tooltip {
    display: none;
    position: fixed;
    top: 120px;
    right: 16px;
    width: 320px;
    background: #2d2d2d;
    color: #fff;
    padding: 16px;
    border-radius: 8px;
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
    z-index: 99999;
    box-shadow: 0 4px 15px rgba(0,0,0,0.5);
}

.tooltip-title {
    font-weight: bold;
    font-size: 13px;
    color: #f37021;
    margin-bottom: 10px;
    padding: 6px 10px;
    border: 1px solid #f37021;
    border-radius: 4px;
    background: rgba(243, 112, 33, 0.1);
}

.commercial-tooltip::after {
    content: "";
    position: absolute;
    top: -6px;
    right: 12px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #2d2d2d;
}

.alert-exclamation:hover .commercial-tooltip {
    display: block;
}

.tooltip-qr {
    width: 100px;
    height: 100px;
    margin-top: 10px;
    border: 3px solid #fff;
    border-radius: 4px;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.tooltip-qr-label {
    margin-top: 6px;
    font-weight: bold;
    color: #1fb5ad;
    font-size: 11px;
}

.exit-edit-btn {
    background: #fff;
    border: 1px solid #aaa;
    color: #666;
    width: 32px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.exit-edit-btn:hover {
    border-color: #f37021;
    color: #f37021;
}

/* ---- WIDGET RELATO DE TURNO ---- */
.relato-turno-widget {
    width: 100%;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    overflow: hidden;
    position: relative;
}

.relato-widget-header {
    background-color: #7d7d7d;
    color: #fff;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    min-height: 36px;
}

.relato-widget-controls {
    display: flex;
    gap: 10px;
    align-items: center;
}

.relato-ctrl-edit {
    color: #ffffff;
    cursor: pointer;
    font-size: 16px;
}

.relato-ctrl-remove {
    color: #e53935;
    cursor: pointer;
    font-size: 18px;
}

.relato-ctrl-remove:hover {
    color: #b71c1c;
}

.relato-sections {
    display: flex;
    flex-direction: column;
    padding: 0;
}

.relato-section {
    display: flex;
    flex-direction: column;
    padding: 12px 14px;
    border-top: 1px solid #f0f0f0;
}

.relato-section:first-child {
    border-top: none;
}

.relato-sub-title {
    font-size: 11px;
    font-weight: bold;
    color: #f37021;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.relato-table-scroll {
    overflow-x: auto;
}

.relato-pgdi-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10px;
}

.relato-pgdi-table th {
    background: #f8f8f8;
    color: #555;
    border: 1px solid #ddd;
    padding: 8px 7px;
    text-align: left;
    text-transform: uppercase;
    font-weight: bold;
}

.relato-pgdi-table td {
    border: 1px solid #eee;
    padding: 8px 7px;
    color: #333;
}

.relato-empty {
    text-align: center;
    color: #999;
    font-style: italic;
    padding: 16px;
}
</style>